"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * My Tours App APIs
 * API documentation for the My Tours client apps
 *
 * OpenAPI spec version: 2.4.0
 * Contact: support@stqry.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MytoursApi = exports.MytoursApiFactory = exports.MytoursApiFp = exports.MytoursApiFetchParamCreator = exports.ImagesApi = exports.ImagesApiFactory = exports.ImagesApiFp = exports.ImagesApiFetchParamCreator = exports.ValidateToken = exports.ValidateCodeResponse = exports.Trigger = exports.RedeemCodeResponse = exports.RedeemCode = exports.Question = exports.ProjectKioskProjectFeatures = exports.ProjectAppProjectFeatures = exports.Placement = exports.OrderItem = exports.Order = exports.MediaItem = exports.MapRoute = exports.MapItem = exports.ManifestKeypadNumbers = exports.LinkedItem = exports.LanguageCode = exports.ItemCompact = exports.InAppPurchaseWebPrice = exports.InAppPurchaseBundleItems = exports.InAppPurchase = exports.GetScreensShowResponseSections = exports.GetScreensShowResponseSectionItems = exports.GetScreensShowResponse = exports.GetMediaItemsShowResponse = exports.GetCollectionsShowResponseSettings = exports.GetCollectionsShowResponseMapLayers = exports.GetCollectionsShowResponse = exports.GetCollectionTriggersIndexResponseData = exports.GetCollectionItemsIndexResponseData = exports.GetAppShowResponse = exports.Geofences = exports.FormField = exports.CreateOrderBody = exports.Badge = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
var url = require("url");
var portableFetch = require("portable-fetch");
var BASE_PATH = "https://stagingapp.mytoursapp.com".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, fetch) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (fetch === void 0) { fetch = portableFetch; }
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = "RequiredError";
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
/**
 * @export
 * @namespace Badge
 */
var Badge;
(function (Badge) {
    /**
     * @export
     * @enum {string}
     */
    var UnearnedLinkTypeEnum;
    (function (UnearnedLinkTypeEnum) {
        UnearnedLinkTypeEnum["Collection"] = "collection";
        UnearnedLinkTypeEnum["Screen"] = "screen";
        UnearnedLinkTypeEnum["CollectionItem"] = "collection_item";
    })(UnearnedLinkTypeEnum = Badge.UnearnedLinkTypeEnum || (Badge.UnearnedLinkTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var UnearnedLinkSubtypeEnum;
    (function (UnearnedLinkSubtypeEnum) {
        UnearnedLinkSubtypeEnum["CollectionList"] = "collection_list";
        UnearnedLinkSubtypeEnum["CollectionTour"] = "collection_tour";
        UnearnedLinkSubtypeEnum["CollectionOrganization"] = "collection_organization";
        UnearnedLinkSubtypeEnum["CollectionMenu"] = "collection_menu";
        UnearnedLinkSubtypeEnum["CollectionSearch"] = "collection_search";
        UnearnedLinkSubtypeEnum["ScreenStory"] = "screen_story";
        UnearnedLinkSubtypeEnum["ScreenWeb"] = "screen_web";
        UnearnedLinkSubtypeEnum["ScreenPanorama"] = "screen_panorama";
        UnearnedLinkSubtypeEnum["ScreenAr"] = "screen_ar";
        UnearnedLinkSubtypeEnum["ScreenKiosk"] = "screen_kiosk";
    })(UnearnedLinkSubtypeEnum = Badge.UnearnedLinkSubtypeEnum || (Badge.UnearnedLinkSubtypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EarnedLinkTypeEnum;
    (function (EarnedLinkTypeEnum) {
        EarnedLinkTypeEnum["Collection"] = "collection";
        EarnedLinkTypeEnum["Screen"] = "screen";
        EarnedLinkTypeEnum["CollectionItem"] = "collection_item";
    })(EarnedLinkTypeEnum = Badge.EarnedLinkTypeEnum || (Badge.EarnedLinkTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EarnedLinkSubtypeEnum;
    (function (EarnedLinkSubtypeEnum) {
        EarnedLinkSubtypeEnum["CollectionList"] = "collection_list";
        EarnedLinkSubtypeEnum["CollectionTour"] = "collection_tour";
        EarnedLinkSubtypeEnum["CollectionOrganization"] = "collection_organization";
        EarnedLinkSubtypeEnum["CollectionMenu"] = "collection_menu";
        EarnedLinkSubtypeEnum["CollectionSearch"] = "collection_search";
        EarnedLinkSubtypeEnum["ScreenStory"] = "screen_story";
        EarnedLinkSubtypeEnum["ScreenWeb"] = "screen_web";
        EarnedLinkSubtypeEnum["ScreenPanorama"] = "screen_panorama";
        EarnedLinkSubtypeEnum["ScreenAr"] = "screen_ar";
        EarnedLinkSubtypeEnum["ScreenKiosk"] = "screen_kiosk";
    })(EarnedLinkSubtypeEnum = Badge.EarnedLinkSubtypeEnum || (Badge.EarnedLinkSubtypeEnum = {}));
})(Badge || (exports.Badge = Badge = {}));
/**
 * @export
 * @namespace CreateOrderBody
 */
var CreateOrderBody;
(function (CreateOrderBody) {
    /**
     * @export
     * @enum {string}
     */
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum["Stripe"] = "stripe";
        OrderTypeEnum["AppStore"] = "app_store";
        OrderTypeEnum["PlayStore"] = "play_store";
    })(OrderTypeEnum = CreateOrderBody.OrderTypeEnum || (CreateOrderBody.OrderTypeEnum = {}));
})(CreateOrderBody || (exports.CreateOrderBody = CreateOrderBody = {}));
/**
 * @export
 * @namespace FormField
 */
var FormField;
(function (FormField) {
    /**
     * @export
     * @enum {string}
     */
    var KindEnum;
    (function (KindEnum) {
        KindEnum["Text"] = "text";
        KindEnum["Email"] = "email";
        KindEnum["CustomField"] = "custom_field";
        KindEnum["MarketingList"] = "marketing_list";
        KindEnum["GivenName"] = "given_name";
        KindEnum["FamilyName"] = "family_name";
        KindEnum["Pronouns"] = "pronouns";
        KindEnum["Gender"] = "gender";
    })(KindEnum = FormField.KindEnum || (FormField.KindEnum = {}));
})(FormField || (exports.FormField = FormField = {}));
/**
 * @export
 * @namespace Geofences
 */
var Geofences;
(function (Geofences) {
    /**
     * @export
     * @enum {string}
     */
    var RelatedTypeEnum;
    (function (RelatedTypeEnum) {
        RelatedTypeEnum["CollectionItem"] = "collection_item";
        RelatedTypeEnum["LinkedItem"] = "linked_item";
        RelatedTypeEnum["Trigger"] = "trigger";
    })(RelatedTypeEnum = Geofences.RelatedTypeEnum || (Geofences.RelatedTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var GeofenceTypeEnum;
    (function (GeofenceTypeEnum) {
        GeofenceTypeEnum["Gps"] = "gps";
        GeofenceTypeEnum["Beacon"] = "beacon";
    })(GeofenceTypeEnum = Geofences.GeofenceTypeEnum || (Geofences.GeofenceTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var LinkedTypeEnum;
    (function (LinkedTypeEnum) {
        LinkedTypeEnum["Collection"] = "collection";
        LinkedTypeEnum["Screen"] = "screen";
        LinkedTypeEnum["Badge"] = "badge";
    })(LinkedTypeEnum = Geofences.LinkedTypeEnum || (Geofences.LinkedTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var LinkedSubtypeEnum;
    (function (LinkedSubtypeEnum) {
        LinkedSubtypeEnum["List"] = "list";
        LinkedSubtypeEnum["Tour"] = "tour";
        LinkedSubtypeEnum["Organization"] = "organization";
        LinkedSubtypeEnum["Menu"] = "menu";
        LinkedSubtypeEnum["Search"] = "search";
        LinkedSubtypeEnum["Story"] = "story";
        LinkedSubtypeEnum["Web"] = "web";
        LinkedSubtypeEnum["Panorama"] = "panorama";
        LinkedSubtypeEnum["Ar"] = "ar";
        LinkedSubtypeEnum["Kiosk"] = "kiosk";
    })(LinkedSubtypeEnum = Geofences.LinkedSubtypeEnum || (Geofences.LinkedSubtypeEnum = {}));
})(Geofences || (exports.Geofences = Geofences = {}));
/**
 * @export
 * @namespace GetAppShowResponse
 */
var GetAppShowResponse;
(function (GetAppShowResponse) {
    /**
     * @export
     * @enum {string}
     */
    var DistanceUnitEnum;
    (function (DistanceUnitEnum) {
        DistanceUnitEnum["Mi"] = "mi";
        DistanceUnitEnum["Km"] = "km";
    })(DistanceUnitEnum = GetAppShowResponse.DistanceUnitEnum || (GetAppShowResponse.DistanceUnitEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var OrientationLockEnum;
    (function (OrientationLockEnum) {
        OrientationLockEnum["None"] = "none";
        OrientationLockEnum["Portrait"] = "portrait";
        OrientationLockEnum["Landscape"] = "landscape";
    })(OrientationLockEnum = GetAppShowResponse.OrientationLockEnum || (GetAppShowResponse.OrientationLockEnum = {}));
})(GetAppShowResponse || (exports.GetAppShowResponse = GetAppShowResponse = {}));
/**
 * @export
 * @namespace GetCollectionItemsIndexResponseData
 */
var GetCollectionItemsIndexResponseData;
(function (GetCollectionItemsIndexResponseData) {
    /**
     * @export
     * @enum {string}
     */
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum["Collection"] = "collection";
        ItemTypeEnum["Screen"] = "screen";
    })(ItemTypeEnum = GetCollectionItemsIndexResponseData.ItemTypeEnum || (GetCollectionItemsIndexResponseData.ItemTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ItemSubtypeEnum;
    (function (ItemSubtypeEnum) {
        ItemSubtypeEnum["List"] = "list";
        ItemSubtypeEnum["Tour"] = "tour";
        ItemSubtypeEnum["Organization"] = "organization";
        ItemSubtypeEnum["Menu"] = "menu";
        ItemSubtypeEnum["Search"] = "search";
        ItemSubtypeEnum["Story"] = "story";
        ItemSubtypeEnum["Web"] = "web";
        ItemSubtypeEnum["Panorama"] = "panorama";
        ItemSubtypeEnum["Ar"] = "ar";
        ItemSubtypeEnum["Kiosk"] = "kiosk";
    })(ItemSubtypeEnum = GetCollectionItemsIndexResponseData.ItemSubtypeEnum || (GetCollectionItemsIndexResponseData.ItemSubtypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var InitialLayoutEnum;
    (function (InitialLayoutEnum) {
        InitialLayoutEnum["Default"] = "default";
        InitialLayoutEnum["Map"] = "map";
    })(InitialLayoutEnum = GetCollectionItemsIndexResponseData.InitialLayoutEnum || (GetCollectionItemsIndexResponseData.InitialLayoutEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var HeaderLayoutEnum;
    (function (HeaderLayoutEnum) {
        HeaderLayoutEnum["ImageAndTitle"] = "image_and_title";
        HeaderLayoutEnum["Image"] = "image";
        HeaderLayoutEnum["None"] = "none";
        HeaderLayoutEnum["Short"] = "short";
        HeaderLayoutEnum["Tall"] = "tall";
    })(HeaderLayoutEnum = GetCollectionItemsIndexResponseData.HeaderLayoutEnum || (GetCollectionItemsIndexResponseData.HeaderLayoutEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MapPinStyleEnum;
    (function (MapPinStyleEnum) {
        MapPinStyleEnum["Default"] = "default";
        MapPinStyleEnum["Regular"] = "regular";
        MapPinStyleEnum["Brands"] = "brands";
        MapPinStyleEnum["Duotone"] = "duotone";
        MapPinStyleEnum["Light"] = "light";
        MapPinStyleEnum["Solid"] = "solid";
    })(MapPinStyleEnum = GetCollectionItemsIndexResponseData.MapPinStyleEnum || (GetCollectionItemsIndexResponseData.MapPinStyleEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var GeofenceModeEnum;
    (function (GeofenceModeEnum) {
        GeofenceModeEnum["Off"] = "off";
        GeofenceModeEnum["Gps"] = "gps";
        GeofenceModeEnum["Beacon"] = "beacon";
    })(GeofenceModeEnum = GetCollectionItemsIndexResponseData.GeofenceModeEnum || (GetCollectionItemsIndexResponseData.GeofenceModeEnum = {}));
})(GetCollectionItemsIndexResponseData || (exports.GetCollectionItemsIndexResponseData = GetCollectionItemsIndexResponseData = {}));
/**
 * @export
 * @namespace GetCollectionTriggersIndexResponseData
 */
var GetCollectionTriggersIndexResponseData;
(function (GetCollectionTriggersIndexResponseData) {
    /**
     * @export
     * @enum {string}
     */
    var GeofenceModeEnum;
    (function (GeofenceModeEnum) {
        GeofenceModeEnum["Off"] = "off";
        GeofenceModeEnum["Gps"] = "gps";
        GeofenceModeEnum["Beacon"] = "beacon";
    })(GeofenceModeEnum = GetCollectionTriggersIndexResponseData.GeofenceModeEnum || (GetCollectionTriggersIndexResponseData.GeofenceModeEnum = {}));
})(GetCollectionTriggersIndexResponseData || (exports.GetCollectionTriggersIndexResponseData = GetCollectionTriggersIndexResponseData = {}));
/**
 * @export
 * @namespace GetCollectionsShowResponse
 */
var GetCollectionsShowResponse;
(function (GetCollectionsShowResponse) {
    /**
     * @export
     * @enum {string}
     */
    var SubtypeEnum;
    (function (SubtypeEnum) {
        SubtypeEnum["CollectionList"] = "CollectionList";
        SubtypeEnum["CollectionTour"] = "CollectionTour";
        SubtypeEnum["CollectionOrganization"] = "CollectionOrganization";
        SubtypeEnum["CollectionMenu"] = "CollectionMenu";
        SubtypeEnum["CollectionSearch"] = "CollectionSearch";
    })(SubtypeEnum = GetCollectionsShowResponse.SubtypeEnum || (GetCollectionsShowResponse.SubtypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MapPinStyleEnum;
    (function (MapPinStyleEnum) {
        MapPinStyleEnum["Default"] = "default";
        MapPinStyleEnum["Regular"] = "regular";
        MapPinStyleEnum["Brands"] = "brands";
        MapPinStyleEnum["Duotone"] = "duotone";
        MapPinStyleEnum["Light"] = "light";
        MapPinStyleEnum["Solid"] = "solid";
    })(MapPinStyleEnum = GetCollectionsShowResponse.MapPinStyleEnum || (GetCollectionsShowResponse.MapPinStyleEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ListLayoutEnum;
    (function (ListLayoutEnum) {
        ListLayoutEnum["Wide"] = "wide";
        ListLayoutEnum["Grid"] = "grid";
        ListLayoutEnum["List"] = "list";
    })(ListLayoutEnum = GetCollectionsShowResponse.ListLayoutEnum || (GetCollectionsShowResponse.ListLayoutEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var SortByEnum;
    (function (SortByEnum) {
        SortByEnum["ListOrder"] = "list_order";
        SortByEnum["Alphabetical"] = "alphabetical";
        SortByEnum["Distance"] = "distance";
    })(SortByEnum = GetCollectionsShowResponse.SortByEnum || (GetCollectionsShowResponse.SortByEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var HeaderLayoutEnum;
    (function (HeaderLayoutEnum) {
        HeaderLayoutEnum["ImageAndTitle"] = "image_and_title";
        HeaderLayoutEnum["Image"] = "image";
        HeaderLayoutEnum["None"] = "none";
        HeaderLayoutEnum["Short"] = "short";
        HeaderLayoutEnum["Tall"] = "tall";
    })(HeaderLayoutEnum = GetCollectionsShowResponse.HeaderLayoutEnum || (GetCollectionsShowResponse.HeaderLayoutEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TourModeEnum;
    (function (TourModeEnum) {
        TourModeEnum["SelfGuided"] = "self_guided";
        TourModeEnum["Guided"] = "guided";
        TourModeEnum["AutoPlay"] = "auto_play";
    })(TourModeEnum = GetCollectionsShowResponse.TourModeEnum || (GetCollectionsShowResponse.TourModeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var AudioModeEnum;
    (function (AudioModeEnum) {
        AudioModeEnum["Replace"] = "replace";
        AudioModeEnum["Skip"] = "skip";
        AudioModeEnum["Queue"] = "queue";
    })(AudioModeEnum = GetCollectionsShowResponse.AudioModeEnum || (GetCollectionsShowResponse.AudioModeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var AllowDownloadEnum;
    (function (AllowDownloadEnum) {
        AllowDownloadEnum["Disabled"] = "disabled";
        AllowDownloadEnum["Optional"] = "optional";
        AllowDownloadEnum["Forced"] = "forced";
        AllowDownloadEnum["ForcedNative"] = "forced_native";
    })(AllowDownloadEnum = GetCollectionsShowResponse.AllowDownloadEnum || (GetCollectionsShowResponse.AllowDownloadEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var InitialLayoutEnum;
    (function (InitialLayoutEnum) {
        InitialLayoutEnum["Default"] = "default";
        InitialLayoutEnum["Map"] = "map";
    })(InitialLayoutEnum = GetCollectionsShowResponse.InitialLayoutEnum || (GetCollectionsShowResponse.InitialLayoutEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TourTypeEnum;
    (function (TourTypeEnum) {
        TourTypeEnum["Walking"] = "walking";
        TourTypeEnum["_4wd"] = "4wd";
        TourTypeEnum["AboriginalSite"] = "aboriginal_site";
        TourTypeEnum["Airplane"] = "airplane";
        TourTypeEnum["Bus"] = "bus";
        TourTypeEnum["Canoeing"] = "canoeing";
        TourTypeEnum["Cycling"] = "cycling";
        TourTypeEnum["Driving"] = "driving";
        TourTypeEnum["Gallery"] = "gallery";
        TourTypeEnum["Helicopter"] = "helicopter";
        TourTypeEnum["HistoricHouse"] = "historic_house";
        TourTypeEnum["HorseTrail"] = "horse_trail";
        TourTypeEnum["Museum"] = "museum";
        TourTypeEnum["NatureTrail"] = "nature_trail";
        TourTypeEnum["ScavengerHunt"] = "scavenger_hunt";
        TourTypeEnum["Ship"] = "ship";
        TourTypeEnum["Train"] = "train";
    })(TourTypeEnum = GetCollectionsShowResponse.TourTypeEnum || (GetCollectionsShowResponse.TourTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TourSubtypeEnum;
    (function (TourSubtypeEnum) {
        TourSubtypeEnum["_1"] = "grade_1";
        TourSubtypeEnum["_2"] = "grade_2";
        TourSubtypeEnum["_3"] = "grade_3";
        TourSubtypeEnum["_4"] = "grade_4";
        TourSubtypeEnum["_5"] = "grade_5";
    })(TourSubtypeEnum = GetCollectionsShowResponse.TourSubtypeEnum || (GetCollectionsShowResponse.TourSubtypeEnum = {}));
})(GetCollectionsShowResponse || (exports.GetCollectionsShowResponse = GetCollectionsShowResponse = {}));
/**
 * @export
 * @namespace GetCollectionsShowResponseMapLayers
 */
var GetCollectionsShowResponseMapLayers;
(function (GetCollectionsShowResponseMapLayers) {
    /**
     * @export
     * @enum {string}
     */
    var LayerTypeEnum;
    (function (LayerTypeEnum) {
        LayerTypeEnum["Mapbox"] = "mapbox";
        LayerTypeEnum["Static"] = "static";
        LayerTypeEnum["Georeferenced"] = "georeferenced";
    })(LayerTypeEnum = GetCollectionsShowResponseMapLayers.LayerTypeEnum || (GetCollectionsShowResponseMapLayers.LayerTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TileFormatEnum;
    (function (TileFormatEnum) {
        TileFormatEnum["PNG"] = "PNG";
        TileFormatEnum["PNG8"] = "PNG8";
        TileFormatEnum["JPEG"] = "JPEG";
    })(TileFormatEnum = GetCollectionsShowResponseMapLayers.TileFormatEnum || (GetCollectionsShowResponseMapLayers.TileFormatEnum = {}));
})(GetCollectionsShowResponseMapLayers || (exports.GetCollectionsShowResponseMapLayers = GetCollectionsShowResponseMapLayers = {}));
/**
 * @export
 * @namespace GetCollectionsShowResponseSettings
 */
var GetCollectionsShowResponseSettings;
(function (GetCollectionsShowResponseSettings) {
    /**
     * @export
     * @enum {string}
     */
    var MinorAlertStyleEnum;
    (function (MinorAlertStyleEnum) {
        MinorAlertStyleEnum["Default"] = "default";
        MinorAlertStyleEnum["Toast"] = "toast";
    })(MinorAlertStyleEnum = GetCollectionsShowResponseSettings.MinorAlertStyleEnum || (GetCollectionsShowResponseSettings.MinorAlertStyleEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MajorAlertStyleEnum;
    (function (MajorAlertStyleEnum) {
        MajorAlertStyleEnum["Default"] = "default";
        MajorAlertStyleEnum["Toast"] = "toast";
    })(MajorAlertStyleEnum = GetCollectionsShowResponseSettings.MajorAlertStyleEnum || (GetCollectionsShowResponseSettings.MajorAlertStyleEnum = {}));
})(GetCollectionsShowResponseSettings || (exports.GetCollectionsShowResponseSettings = GetCollectionsShowResponseSettings = {}));
/**
 * @export
 * @namespace GetMediaItemsShowResponse
 */
var GetMediaItemsShowResponse;
(function (GetMediaItemsShowResponse) {
    /**
     * @export
     * @enum {string}
     */
    var RemoteTypeEnum;
    (function (RemoteTypeEnum) {
        RemoteTypeEnum["Youtube"] = "youtube";
        RemoteTypeEnum["Vimeo"] = "vimeo";
    })(RemoteTypeEnum = GetMediaItemsShowResponse.RemoteTypeEnum || (GetMediaItemsShowResponse.RemoteTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MediaTypeEnum;
    (function (MediaTypeEnum) {
        MediaTypeEnum["Map"] = "map";
        MediaTypeEnum["Webpackage"] = "webpackage";
        MediaTypeEnum["Animation"] = "animation";
        MediaTypeEnum["Audio"] = "audio";
        MediaTypeEnum["Image"] = "image";
        MediaTypeEnum["Video"] = "video";
        MediaTypeEnum["Webvideo"] = "webvideo";
        MediaTypeEnum["Ar"] = "ar";
        MediaTypeEnum["Data"] = "data";
    })(MediaTypeEnum = GetMediaItemsShowResponse.MediaTypeEnum || (GetMediaItemsShowResponse.MediaTypeEnum = {}));
})(GetMediaItemsShowResponse || (exports.GetMediaItemsShowResponse = GetMediaItemsShowResponse = {}));
/**
 * @export
 * @namespace GetScreensShowResponse
 */
var GetScreensShowResponse;
(function (GetScreensShowResponse) {
    /**
     * @export
     * @enum {string}
     */
    var ScreenTypeEnum;
    (function (ScreenTypeEnum) {
        ScreenTypeEnum["Story"] = "story";
        ScreenTypeEnum["Web"] = "web";
        ScreenTypeEnum["Panorama"] = "panorama";
        ScreenTypeEnum["Ar"] = "ar";
        ScreenTypeEnum["Kiosk"] = "kiosk";
    })(ScreenTypeEnum = GetScreensShowResponse.ScreenTypeEnum || (GetScreensShowResponse.ScreenTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var PageTypeEnum;
    (function (PageTypeEnum) {
        PageTypeEnum["URL"] = "URL";
        PageTypeEnum["HTML"] = "HTML";
        PageTypeEnum["ZIP"] = "ZIP";
        PageTypeEnum["NA"] = "NA";
        PageTypeEnum["UNITY"] = "UNITY";
    })(PageTypeEnum = GetScreensShowResponse.PageTypeEnum || (GetScreensShowResponse.PageTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var HeaderLayoutEnum;
    (function (HeaderLayoutEnum) {
        HeaderLayoutEnum["ImageAndTitle"] = "image_and_title";
        HeaderLayoutEnum["Image"] = "image";
        HeaderLayoutEnum["None"] = "none";
        HeaderLayoutEnum["Short"] = "short";
        HeaderLayoutEnum["Tall"] = "tall";
    })(HeaderLayoutEnum = GetScreensShowResponse.HeaderLayoutEnum || (GetScreensShowResponse.HeaderLayoutEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var LayoutEnum;
    (function (LayoutEnum) {
        LayoutEnum["Hotspots"] = "hotspots";
        LayoutEnum["Web"] = "web";
        LayoutEnum["Canvas"] = "canvas";
    })(LayoutEnum = GetScreensShowResponse.LayoutEnum || (GetScreensShowResponse.LayoutEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MapPinStyleEnum;
    (function (MapPinStyleEnum) {
        MapPinStyleEnum["Default"] = "default";
        MapPinStyleEnum["Regular"] = "regular";
        MapPinStyleEnum["Brands"] = "brands";
        MapPinStyleEnum["Duotone"] = "duotone";
        MapPinStyleEnum["Light"] = "light";
        MapPinStyleEnum["Solid"] = "solid";
    })(MapPinStyleEnum = GetScreensShowResponse.MapPinStyleEnum || (GetScreensShowResponse.MapPinStyleEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ImageTypeEnum;
    (function (ImageTypeEnum) {
        ImageTypeEnum["Panorama"] = "panorama";
        ImageTypeEnum["Flat"] = "flat";
    })(ImageTypeEnum = GetScreensShowResponse.ImageTypeEnum || (GetScreensShowResponse.ImageTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ScrollingEnum;
    (function (ScrollingEnum) {
        ScrollingEnum["None"] = "none";
        ScrollingEnum["Vertical"] = "vertical";
        ScrollingEnum["Horizontal"] = "horizontal";
        ScrollingEnum["Zoomable"] = "zoomable";
    })(ScrollingEnum = GetScreensShowResponse.ScrollingEnum || (GetScreensShowResponse.ScrollingEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var AllowDownloadEnum;
    (function (AllowDownloadEnum) {
        AllowDownloadEnum["Disabled"] = "disabled";
        AllowDownloadEnum["Optional"] = "optional";
        AllowDownloadEnum["Forced"] = "forced";
        AllowDownloadEnum["ForcedNative"] = "forced_native";
    })(AllowDownloadEnum = GetScreensShowResponse.AllowDownloadEnum || (GetScreensShowResponse.AllowDownloadEnum = {}));
})(GetScreensShowResponse || (exports.GetScreensShowResponse = GetScreensShowResponse = {}));
/**
 * @export
 * @namespace GetScreensShowResponseSectionItems
 */
var GetScreensShowResponseSectionItems;
(function (GetScreensShowResponseSectionItems) {
    /**
     * @export
     * @enum {string}
     */
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum["Collection"] = "collection";
        ItemTypeEnum["CollectionItem"] = "collection_item";
        ItemTypeEnum["Screen"] = "screen";
        ItemTypeEnum["MediaItem"] = "media_item";
        ItemTypeEnum["CrossRegionLink"] = "cross_region_link";
    })(ItemTypeEnum = GetScreensShowResponseSectionItems.ItemTypeEnum || (GetScreensShowResponseSectionItems.ItemTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var LinkTypeEnum;
    (function (LinkTypeEnum) {
        LinkTypeEnum["Twitter"] = "twitter";
        LinkTypeEnum["Whatsapp"] = "whatsapp";
        LinkTypeEnum["Wechat"] = "wechat";
        LinkTypeEnum["Facebook"] = "facebook";
        LinkTypeEnum["Instagram"] = "instagram";
        LinkTypeEnum["Pinterest"] = "pinterest";
        LinkTypeEnum["Youtube"] = "youtube";
        LinkTypeEnum["Vimeo"] = "vimeo";
        LinkTypeEnum["Linkedin"] = "linkedin";
        LinkTypeEnum["Tiktok"] = "tiktok";
        LinkTypeEnum["Weibo"] = "weibo";
        LinkTypeEnum["Bluesky"] = "bluesky";
        LinkTypeEnum["Internal"] = "internal";
        LinkTypeEnum["Url"] = "url";
        LinkTypeEnum["Email"] = "email";
        LinkTypeEnum["Phone"] = "phone";
        LinkTypeEnum["LiveTours"] = "live_tours";
        LinkTypeEnum["Settings"] = "settings";
        LinkTypeEnum["Badges"] = "badges";
        LinkTypeEnum["Favourites"] = "favourites";
        LinkTypeEnum["Download"] = "download";
        LinkTypeEnum["AppRating"] = "app_rating";
    })(LinkTypeEnum = GetScreensShowResponseSectionItems.LinkTypeEnum || (GetScreensShowResponseSectionItems.LinkTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ItemSubtypeEnum;
    (function (ItemSubtypeEnum) {
        ItemSubtypeEnum["CollectionList"] = "collection_list";
        ItemSubtypeEnum["CollectionTour"] = "collection_tour";
        ItemSubtypeEnum["CollectionOrganization"] = "collection_organization";
        ItemSubtypeEnum["CollectionMenu"] = "collection_menu";
        ItemSubtypeEnum["CollectionSearch"] = "collection_search";
        ItemSubtypeEnum["ScreenStory"] = "screen_story";
        ItemSubtypeEnum["ScreenWeb"] = "screen_web";
        ItemSubtypeEnum["ScreenPanorama"] = "screen_panorama";
        ItemSubtypeEnum["ScreenAr"] = "screen_ar";
        ItemSubtypeEnum["ScreenKiosk"] = "screen_kiosk";
    })(ItemSubtypeEnum = GetScreensShowResponseSectionItems.ItemSubtypeEnum || (GetScreensShowResponseSectionItems.ItemSubtypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var SocialNetworkEnum;
    (function (SocialNetworkEnum) {
        SocialNetworkEnum["Twitter"] = "twitter";
        SocialNetworkEnum["Whatsapp"] = "whatsapp";
        SocialNetworkEnum["Wechat"] = "wechat";
        SocialNetworkEnum["Facebook"] = "facebook";
        SocialNetworkEnum["Instagram"] = "instagram";
        SocialNetworkEnum["Pinterest"] = "pinterest";
        SocialNetworkEnum["Youtube"] = "youtube";
        SocialNetworkEnum["Vimeo"] = "vimeo";
        SocialNetworkEnum["Linkedin"] = "linkedin";
        SocialNetworkEnum["Tiktok"] = "tiktok";
        SocialNetworkEnum["Weibo"] = "weibo";
        SocialNetworkEnum["Bluesky"] = "bluesky";
    })(SocialNetworkEnum = GetScreensShowResponseSectionItems.SocialNetworkEnum || (GetScreensShowResponseSectionItems.SocialNetworkEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MediaTypeEnum;
    (function (MediaTypeEnum) {
        MediaTypeEnum["Map"] = "map";
        MediaTypeEnum["Webpackage"] = "webpackage";
        MediaTypeEnum["Animation"] = "animation";
        MediaTypeEnum["Audio"] = "audio";
        MediaTypeEnum["Image"] = "image";
        MediaTypeEnum["Video"] = "video";
        MediaTypeEnum["Webvideo"] = "webvideo";
        MediaTypeEnum["Ar"] = "ar";
        MediaTypeEnum["Data"] = "data";
    })(MediaTypeEnum = GetScreensShowResponseSectionItems.MediaTypeEnum || (GetScreensShowResponseSectionItems.MediaTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var RemoteTypeEnum;
    (function (RemoteTypeEnum) {
        RemoteTypeEnum["Youtube"] = "youtube";
        RemoteTypeEnum["Vimeo"] = "vimeo";
    })(RemoteTypeEnum = GetScreensShowResponseSectionItems.RemoteTypeEnum || (GetScreensShowResponseSectionItems.RemoteTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var PriceCurrencyEnum;
    (function (PriceCurrencyEnum) {
        PriceCurrencyEnum["AED"] = "AED";
        PriceCurrencyEnum["AFN"] = "AFN";
        PriceCurrencyEnum["ALL"] = "ALL";
        PriceCurrencyEnum["AMD"] = "AMD";
        PriceCurrencyEnum["ANG"] = "ANG";
        PriceCurrencyEnum["AOA"] = "AOA";
        PriceCurrencyEnum["ARS"] = "ARS";
        PriceCurrencyEnum["AUD"] = "AUD";
        PriceCurrencyEnum["AWG"] = "AWG";
        PriceCurrencyEnum["AZN"] = "AZN";
        PriceCurrencyEnum["BAM"] = "BAM";
        PriceCurrencyEnum["BBD"] = "BBD";
        PriceCurrencyEnum["BDT"] = "BDT";
        PriceCurrencyEnum["BGN"] = "BGN";
        PriceCurrencyEnum["BHD"] = "BHD";
        PriceCurrencyEnum["BIF"] = "BIF";
        PriceCurrencyEnum["BMD"] = "BMD";
        PriceCurrencyEnum["BND"] = "BND";
        PriceCurrencyEnum["BOB"] = "BOB";
        PriceCurrencyEnum["BRL"] = "BRL";
        PriceCurrencyEnum["BSD"] = "BSD";
        PriceCurrencyEnum["BTN"] = "BTN";
        PriceCurrencyEnum["BWP"] = "BWP";
        PriceCurrencyEnum["BYN"] = "BYN";
        PriceCurrencyEnum["BYR"] = "BYR";
        PriceCurrencyEnum["BZD"] = "BZD";
        PriceCurrencyEnum["CAD"] = "CAD";
        PriceCurrencyEnum["CDF"] = "CDF";
        PriceCurrencyEnum["CHF"] = "CHF";
        PriceCurrencyEnum["CLF"] = "CLF";
        PriceCurrencyEnum["CLP"] = "CLP";
        PriceCurrencyEnum["CNY"] = "CNY";
        PriceCurrencyEnum["COP"] = "COP";
        PriceCurrencyEnum["CRC"] = "CRC";
        PriceCurrencyEnum["CUC"] = "CUC";
        PriceCurrencyEnum["CUP"] = "CUP";
        PriceCurrencyEnum["CVE"] = "CVE";
        PriceCurrencyEnum["CZK"] = "CZK";
        PriceCurrencyEnum["DJF"] = "DJF";
        PriceCurrencyEnum["DKK"] = "DKK";
        PriceCurrencyEnum["DOP"] = "DOP";
        PriceCurrencyEnum["DZD"] = "DZD";
        PriceCurrencyEnum["EGP"] = "EGP";
        PriceCurrencyEnum["ERN"] = "ERN";
        PriceCurrencyEnum["ETB"] = "ETB";
        PriceCurrencyEnum["EUR"] = "EUR";
        PriceCurrencyEnum["FJD"] = "FJD";
        PriceCurrencyEnum["FKP"] = "FKP";
        PriceCurrencyEnum["GBP"] = "GBP";
        PriceCurrencyEnum["GEL"] = "GEL";
        PriceCurrencyEnum["GHS"] = "GHS";
        PriceCurrencyEnum["GIP"] = "GIP";
        PriceCurrencyEnum["GMD"] = "GMD";
        PriceCurrencyEnum["GNF"] = "GNF";
        PriceCurrencyEnum["GTQ"] = "GTQ";
        PriceCurrencyEnum["GYD"] = "GYD";
        PriceCurrencyEnum["HKD"] = "HKD";
        PriceCurrencyEnum["HNL"] = "HNL";
        PriceCurrencyEnum["HTG"] = "HTG";
        PriceCurrencyEnum["HUF"] = "HUF";
        PriceCurrencyEnum["IDR"] = "IDR";
        PriceCurrencyEnum["ILS"] = "ILS";
        PriceCurrencyEnum["INR"] = "INR";
        PriceCurrencyEnum["IQD"] = "IQD";
        PriceCurrencyEnum["IRR"] = "IRR";
        PriceCurrencyEnum["ISK"] = "ISK";
        PriceCurrencyEnum["JMD"] = "JMD";
        PriceCurrencyEnum["JOD"] = "JOD";
        PriceCurrencyEnum["JPY"] = "JPY";
        PriceCurrencyEnum["KES"] = "KES";
        PriceCurrencyEnum["KGS"] = "KGS";
        PriceCurrencyEnum["KHR"] = "KHR";
        PriceCurrencyEnum["KMF"] = "KMF";
        PriceCurrencyEnum["KPW"] = "KPW";
        PriceCurrencyEnum["KRW"] = "KRW";
        PriceCurrencyEnum["KWD"] = "KWD";
        PriceCurrencyEnum["KYD"] = "KYD";
        PriceCurrencyEnum["KZT"] = "KZT";
        PriceCurrencyEnum["LAK"] = "LAK";
        PriceCurrencyEnum["LBP"] = "LBP";
        PriceCurrencyEnum["LKR"] = "LKR";
        PriceCurrencyEnum["LRD"] = "LRD";
        PriceCurrencyEnum["LSL"] = "LSL";
        PriceCurrencyEnum["LYD"] = "LYD";
        PriceCurrencyEnum["MAD"] = "MAD";
        PriceCurrencyEnum["MDL"] = "MDL";
        PriceCurrencyEnum["MGA"] = "MGA";
        PriceCurrencyEnum["MKD"] = "MKD";
        PriceCurrencyEnum["MMK"] = "MMK";
        PriceCurrencyEnum["MNT"] = "MNT";
        PriceCurrencyEnum["MOP"] = "MOP";
        PriceCurrencyEnum["MRU"] = "MRU";
        PriceCurrencyEnum["MUR"] = "MUR";
        PriceCurrencyEnum["MVR"] = "MVR";
        PriceCurrencyEnum["MWK"] = "MWK";
        PriceCurrencyEnum["MXN"] = "MXN";
        PriceCurrencyEnum["MYR"] = "MYR";
        PriceCurrencyEnum["MZN"] = "MZN";
        PriceCurrencyEnum["NAD"] = "NAD";
        PriceCurrencyEnum["NGN"] = "NGN";
        PriceCurrencyEnum["NIO"] = "NIO";
        PriceCurrencyEnum["NOK"] = "NOK";
        PriceCurrencyEnum["NPR"] = "NPR";
        PriceCurrencyEnum["NZD"] = "NZD";
        PriceCurrencyEnum["OMR"] = "OMR";
        PriceCurrencyEnum["PAB"] = "PAB";
        PriceCurrencyEnum["PEN"] = "PEN";
        PriceCurrencyEnum["PGK"] = "PGK";
        PriceCurrencyEnum["PHP"] = "PHP";
        PriceCurrencyEnum["PKR"] = "PKR";
        PriceCurrencyEnum["PLN"] = "PLN";
        PriceCurrencyEnum["PYG"] = "PYG";
        PriceCurrencyEnum["QAR"] = "QAR";
        PriceCurrencyEnum["RON"] = "RON";
        PriceCurrencyEnum["RSD"] = "RSD";
        PriceCurrencyEnum["RUB"] = "RUB";
        PriceCurrencyEnum["RWF"] = "RWF";
        PriceCurrencyEnum["SAR"] = "SAR";
        PriceCurrencyEnum["SBD"] = "SBD";
        PriceCurrencyEnum["SCR"] = "SCR";
        PriceCurrencyEnum["SDG"] = "SDG";
        PriceCurrencyEnum["SEK"] = "SEK";
        PriceCurrencyEnum["SGD"] = "SGD";
        PriceCurrencyEnum["SHP"] = "SHP";
        PriceCurrencyEnum["SKK"] = "SKK";
        PriceCurrencyEnum["SLE"] = "SLE";
        PriceCurrencyEnum["SLL"] = "SLL";
        PriceCurrencyEnum["SOS"] = "SOS";
        PriceCurrencyEnum["SRD"] = "SRD";
        PriceCurrencyEnum["SSP"] = "SSP";
        PriceCurrencyEnum["STD"] = "STD";
        PriceCurrencyEnum["STN"] = "STN";
        PriceCurrencyEnum["SVC"] = "SVC";
        PriceCurrencyEnum["SYP"] = "SYP";
        PriceCurrencyEnum["SZL"] = "SZL";
        PriceCurrencyEnum["THB"] = "THB";
        PriceCurrencyEnum["TJS"] = "TJS";
        PriceCurrencyEnum["TMT"] = "TMT";
        PriceCurrencyEnum["TND"] = "TND";
        PriceCurrencyEnum["TOP"] = "TOP";
        PriceCurrencyEnum["TRY"] = "TRY";
        PriceCurrencyEnum["TTD"] = "TTD";
        PriceCurrencyEnum["TWD"] = "TWD";
        PriceCurrencyEnum["TZS"] = "TZS";
        PriceCurrencyEnum["UAH"] = "UAH";
        PriceCurrencyEnum["UGX"] = "UGX";
        PriceCurrencyEnum["USD"] = "USD";
        PriceCurrencyEnum["UYU"] = "UYU";
        PriceCurrencyEnum["UZS"] = "UZS";
        PriceCurrencyEnum["VES"] = "VES";
        PriceCurrencyEnum["VND"] = "VND";
        PriceCurrencyEnum["VUV"] = "VUV";
        PriceCurrencyEnum["WST"] = "WST";
        PriceCurrencyEnum["XAF"] = "XAF";
        PriceCurrencyEnum["XAG"] = "XAG";
        PriceCurrencyEnum["XAU"] = "XAU";
        PriceCurrencyEnum["XBA"] = "XBA";
        PriceCurrencyEnum["XBB"] = "XBB";
        PriceCurrencyEnum["XBC"] = "XBC";
        PriceCurrencyEnum["XBD"] = "XBD";
        PriceCurrencyEnum["XCD"] = "XCD";
        PriceCurrencyEnum["XDR"] = "XDR";
        PriceCurrencyEnum["XOF"] = "XOF";
        PriceCurrencyEnum["XPD"] = "XPD";
        PriceCurrencyEnum["XPF"] = "XPF";
        PriceCurrencyEnum["XPT"] = "XPT";
        PriceCurrencyEnum["XTS"] = "XTS";
        PriceCurrencyEnum["YER"] = "YER";
        PriceCurrencyEnum["ZAR"] = "ZAR";
        PriceCurrencyEnum["ZMK"] = "ZMK";
        PriceCurrencyEnum["ZMW"] = "ZMW";
        PriceCurrencyEnum["BCH"] = "BCH";
        PriceCurrencyEnum["BTC"] = "BTC";
        PriceCurrencyEnum["JEP"] = "JEP";
        PriceCurrencyEnum["GGP"] = "GGP";
        PriceCurrencyEnum["IMP"] = "IMP";
        PriceCurrencyEnum["XFU"] = "XFU";
        PriceCurrencyEnum["GBX"] = "GBX";
        PriceCurrencyEnum["CNH"] = "CNH";
        PriceCurrencyEnum["USDC"] = "USDC";
        PriceCurrencyEnum["EEK"] = "EEK";
        PriceCurrencyEnum["HRK"] = "HRK";
        PriceCurrencyEnum["LTL"] = "LTL";
        PriceCurrencyEnum["LVL"] = "LVL";
        PriceCurrencyEnum["MRO"] = "MRO";
        PriceCurrencyEnum["MTL"] = "MTL";
        PriceCurrencyEnum["TMM"] = "TMM";
        PriceCurrencyEnum["ZWD"] = "ZWD";
        PriceCurrencyEnum["ZWL"] = "ZWL";
        PriceCurrencyEnum["ZWN"] = "ZWN";
        PriceCurrencyEnum["ZWR"] = "ZWR";
        PriceCurrencyEnum["VEF"] = "VEF";
        PriceCurrencyEnum["XCG"] = "XCG";
        PriceCurrencyEnum["ZWG"] = "ZWG";
    })(PriceCurrencyEnum = GetScreensShowResponseSectionItems.PriceCurrencyEnum || (GetScreensShowResponseSectionItems.PriceCurrencyEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var IconTypeEnum;
    (function (IconTypeEnum) {
        IconTypeEnum["MediaItem"] = "media_item";
        IconTypeEnum["StockIcon"] = "stock_icon";
        IconTypeEnum["Clear"] = "clear";
    })(IconTypeEnum = GetScreensShowResponseSectionItems.IconTypeEnum || (GetScreensShowResponseSectionItems.IconTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var StockIconStyleEnum;
    (function (StockIconStyleEnum) {
        StockIconStyleEnum["Default"] = "default";
        StockIconStyleEnum["Regular"] = "regular";
        StockIconStyleEnum["Brands"] = "brands";
        StockIconStyleEnum["Duotone"] = "duotone";
        StockIconStyleEnum["Light"] = "light";
        StockIconStyleEnum["Solid"] = "solid";
    })(StockIconStyleEnum = GetScreensShowResponseSectionItems.StockIconStyleEnum || (GetScreensShowResponseSectionItems.StockIconStyleEnum = {}));
})(GetScreensShowResponseSectionItems || (exports.GetScreensShowResponseSectionItems = GetScreensShowResponseSectionItems = {}));
/**
 * @export
 * @namespace GetScreensShowResponseSections
 */
var GetScreensShowResponseSections;
(function (GetScreensShowResponseSections) {
    /**
     * @export
     * @enum {string}
     */
    var SectionTypeEnum;
    (function (SectionTypeEnum) {
        SectionTypeEnum["LinkGroup"] = "link_group";
        SectionTypeEnum["Location"] = "location";
        SectionTypeEnum["MediaGroup"] = "media_group";
        SectionTypeEnum["Menu"] = "menu";
        SectionTypeEnum["PriceGroup"] = "price_group";
        SectionTypeEnum["SocialGroup"] = "social_group";
        SectionTypeEnum["OpeningTimeGroup"] = "opening_time_group";
        SectionTypeEnum["Text"] = "text";
        SectionTypeEnum["ImageSlider"] = "image_slider";
        SectionTypeEnum["QuizQuestion"] = "quiz_question";
        SectionTypeEnum["QuizScore"] = "quiz_score";
        SectionTypeEnum["CustomWidget"] = "custom_widget";
        SectionTypeEnum["SingleMedia"] = "single_media";
        SectionTypeEnum["Form"] = "form";
        SectionTypeEnum["BadgeGroup"] = "badge_group";
    })(SectionTypeEnum = GetScreensShowResponseSections.SectionTypeEnum || (GetScreensShowResponseSections.SectionTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var LayoutEnum;
    (function (LayoutEnum) {
        LayoutEnum["Icons"] = "icons";
        LayoutEnum["List"] = "list";
        LayoutEnum["Button"] = "button";
        LayoutEnum["Icon"] = "icon";
        LayoutEnum["ListNoIcon"] = "list_no_icon";
        LayoutEnum["ButtonNoIcon"] = "button_no_icon";
        LayoutEnum["ListWithIcon"] = "list_with_icon";
        LayoutEnum["ButtonWithIcon"] = "button_with_icon";
        LayoutEnum["GridImage"] = "grid_image";
        LayoutEnum["WideImage"] = "wide_image";
        LayoutEnum["HorizontalSlider"] = "horizontal_slider";
    })(LayoutEnum = GetScreensShowResponseSections.LayoutEnum || (GetScreensShowResponseSections.LayoutEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MapPinStyleEnum;
    (function (MapPinStyleEnum) {
        MapPinStyleEnum["Default"] = "default";
        MapPinStyleEnum["Regular"] = "regular";
        MapPinStyleEnum["Brands"] = "brands";
        MapPinStyleEnum["Duotone"] = "duotone";
        MapPinStyleEnum["Light"] = "light";
        MapPinStyleEnum["Solid"] = "solid";
    })(MapPinStyleEnum = GetScreensShowResponseSections.MapPinStyleEnum || (GetScreensShowResponseSections.MapPinStyleEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MapTypeEnum;
    (function (MapTypeEnum) {
        MapTypeEnum["SingleLocation"] = "single_location";
        MapTypeEnum["MultipleLocations"] = "multiple_locations";
    })(MapTypeEnum = GetScreensShowResponseSections.MapTypeEnum || (GetScreensShowResponseSections.MapTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TextPositionEnum;
    (function (TextPositionEnum) {
        TextPositionEnum["Left"] = "left";
        TextPositionEnum["Right"] = "right";
        TextPositionEnum["Top"] = "top";
        TextPositionEnum["Bottom"] = "bottom";
        TextPositionEnum["None"] = "none";
    })(TextPositionEnum = GetScreensShowResponseSections.TextPositionEnum || (GetScreensShowResponseSections.TextPositionEnum = {}));
})(GetScreensShowResponseSections || (exports.GetScreensShowResponseSections = GetScreensShowResponseSections = {}));
/**
 * @export
 * @namespace InAppPurchase
 */
var InAppPurchase;
(function (InAppPurchase) {
    /**
     * @export
     * @enum {string}
     */
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum["Collection"] = "collection";
        ItemTypeEnum["Screen"] = "screen";
        ItemTypeEnum["Bundle"] = "bundle";
    })(ItemTypeEnum = InAppPurchase.ItemTypeEnum || (InAppPurchase.ItemTypeEnum = {}));
})(InAppPurchase || (exports.InAppPurchase = InAppPurchase = {}));
/**
 * @export
 * @namespace InAppPurchaseBundleItems
 */
var InAppPurchaseBundleItems;
(function (InAppPurchaseBundleItems) {
    /**
     * @export
     * @enum {string}
     */
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum["Collection"] = "collection";
        ItemTypeEnum["Screen"] = "screen";
    })(ItemTypeEnum = InAppPurchaseBundleItems.ItemTypeEnum || (InAppPurchaseBundleItems.ItemTypeEnum = {}));
})(InAppPurchaseBundleItems || (exports.InAppPurchaseBundleItems = InAppPurchaseBundleItems = {}));
/**
 * @export
 * @namespace InAppPurchaseWebPrice
 */
var InAppPurchaseWebPrice;
(function (InAppPurchaseWebPrice) {
    /**
     * @export
     * @enum {string}
     */
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum["AED"] = "AED";
        CurrencyEnum["EUR"] = "EUR";
        CurrencyEnum["AUD"] = "AUD";
        CurrencyEnum["BGN"] = "BGN";
        CurrencyEnum["USD"] = "USD";
        CurrencyEnum["BOB"] = "BOB";
        CurrencyEnum["BRL"] = "BRL";
        CurrencyEnum["CAD"] = "CAD";
        CurrencyEnum["CHF"] = "CHF";
        CurrencyEnum["CLP"] = "CLP";
        CurrencyEnum["COP"] = "COP";
        CurrencyEnum["CRC"] = "CRC";
        CurrencyEnum["CZK"] = "CZK";
        CurrencyEnum["DKK"] = "DKK";
        CurrencyEnum["EGP"] = "EGP";
        CurrencyEnum["GBP"] = "GBP";
        CurrencyEnum["HKD"] = "HKD";
        CurrencyEnum["HRK"] = "HRK";
        CurrencyEnum["HUF"] = "HUF";
        CurrencyEnum["IDR"] = "IDR";
        CurrencyEnum["ILS"] = "ILS";
        CurrencyEnum["INR"] = "INR";
        CurrencyEnum["JPY"] = "JPY";
        CurrencyEnum["KRW"] = "KRW";
        CurrencyEnum["KZT"] = "KZT";
        CurrencyEnum["LBP"] = "LBP";
        CurrencyEnum["MAD"] = "MAD";
        CurrencyEnum["MXN"] = "MXN";
        CurrencyEnum["MYR"] = "MYR";
        CurrencyEnum["NGN"] = "NGN";
        CurrencyEnum["NOK"] = "NOK";
        CurrencyEnum["NZD"] = "NZD";
        CurrencyEnum["PEN"] = "PEN";
        CurrencyEnum["PHP"] = "PHP";
        CurrencyEnum["PKR"] = "PKR";
        CurrencyEnum["PLN"] = "PLN";
        CurrencyEnum["QAR"] = "QAR";
        CurrencyEnum["RON"] = "RON";
        CurrencyEnum["RUB"] = "RUB";
        CurrencyEnum["SAR"] = "SAR";
        CurrencyEnum["SEK"] = "SEK";
        CurrencyEnum["SGD"] = "SGD";
        CurrencyEnum["THB"] = "THB";
        CurrencyEnum["TRY"] = "TRY";
        CurrencyEnum["TWD"] = "TWD";
        CurrencyEnum["UAH"] = "UAH";
        CurrencyEnum["VND"] = "VND";
        CurrencyEnum["ZAR"] = "ZAR";
    })(CurrencyEnum = InAppPurchaseWebPrice.CurrencyEnum || (InAppPurchaseWebPrice.CurrencyEnum = {}));
})(InAppPurchaseWebPrice || (exports.InAppPurchaseWebPrice = InAppPurchaseWebPrice = {}));
/**
 * @export
 * @namespace ItemCompact
 */
var ItemCompact;
(function (ItemCompact) {
    /**
     * @export
     * @enum {string}
     */
    var CachedEnum;
    (function (CachedEnum) {
        CachedEnum["P"] = "p";
        CachedEnum["D"] = "d";
        CachedEnum["B"] = "b";
    })(CachedEnum = ItemCompact.CachedEnum || (ItemCompact.CachedEnum = {}));
})(ItemCompact || (exports.ItemCompact = ItemCompact = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["Alq"] = "alq";
    LanguageCode["Ar"] = "ar";
    LanguageCode["Bg"] = "bg";
    LanguageCode["Ca"] = "ca";
    LanguageCode["Cy"] = "cy";
    LanguageCode["Da"] = "da";
    LanguageCode["De"] = "de";
    LanguageCode["El"] = "el";
    LanguageCode["En"] = "en";
    LanguageCode["EnGB"] = "en-GB";
    LanguageCode["Es"] = "es";
    LanguageCode["Eu"] = "eu";
    LanguageCode["Fa"] = "fa";
    LanguageCode["Fi"] = "fi";
    LanguageCode["Fj"] = "fj";
    LanguageCode["Fo"] = "fo";
    LanguageCode["Fr"] = "fr";
    LanguageCode["Ga"] = "ga";
    LanguageCode["Haw"] = "haw";
    LanguageCode["He"] = "he";
    LanguageCode["Hi"] = "hi";
    LanguageCode["Hmn"] = "hmn";
    LanguageCode["Ht"] = "ht";
    LanguageCode["Hu"] = "hu";
    LanguageCode["Hy"] = "hy";
    LanguageCode["Id"] = "id";
    LanguageCode["Is"] = "is";
    LanguageCode["It"] = "it";
    LanguageCode["Ja"] = "ja";
    LanguageCode["Ka"] = "ka";
    LanguageCode["Ko"] = "ko";
    LanguageCode["Lkt"] = "lkt";
    LanguageCode["Lld"] = "lld";
    LanguageCode["Lo"] = "lo";
    LanguageCode["Lt"] = "lt";
    LanguageCode["Lv"] = "lv";
    LanguageCode["Mi"] = "mi";
    LanguageCode["Ms"] = "ms";
    LanguageCode["Ne"] = "ne";
    LanguageCode["Nl"] = "nl";
    LanguageCode["No"] = "no";
    LanguageCode["Oji"] = "oji";
    LanguageCode["Pa"] = "pa";
    LanguageCode["Pap"] = "pap";
    LanguageCode["Pl"] = "pl";
    LanguageCode["Pt"] = "pt";
    LanguageCode["PtBR"] = "pt-BR";
    LanguageCode["Ro"] = "ro";
    LanguageCode["Ru"] = "ru";
    LanguageCode["Sm"] = "sm";
    LanguageCode["So"] = "so";
    LanguageCode["St"] = "st";
    LanguageCode["Sv"] = "sv";
    LanguageCode["Ta"] = "ta";
    LanguageCode["Th"] = "th";
    LanguageCode["Tl"] = "tl";
    LanguageCode["Tn"] = "tn";
    LanguageCode["To"] = "to";
    LanguageCode["Tr"] = "tr";
    LanguageCode["Uk"] = "uk";
    LanguageCode["Vi"] = "vi";
    LanguageCode["Xh"] = "xh";
    LanguageCode["ZhHans"] = "zh-Hans";
    LanguageCode["ZhHant"] = "zh-Hant";
    LanguageCode["Zu"] = "zu";
})(LanguageCode || (exports.LanguageCode = LanguageCode = {}));
/**
 * @export
 * @namespace LinkedItem
 */
var LinkedItem;
(function (LinkedItem) {
    /**
     * @export
     * @enum {string}
     */
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum["Screen"] = "screen";
        ItemTypeEnum["Collection"] = "collection";
        ItemTypeEnum["MediaItem"] = "media_item";
    })(ItemTypeEnum = LinkedItem.ItemTypeEnum || (LinkedItem.ItemTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ItemSubtypeEnum;
    (function (ItemSubtypeEnum) {
        ItemSubtypeEnum["Map"] = "map";
        ItemSubtypeEnum["Webpackage"] = "webpackage";
        ItemSubtypeEnum["Animation"] = "animation";
        ItemSubtypeEnum["Audio"] = "audio";
        ItemSubtypeEnum["Image"] = "image";
        ItemSubtypeEnum["Video"] = "video";
        ItemSubtypeEnum["Webvideo"] = "webvideo";
        ItemSubtypeEnum["Ar"] = "ar";
        ItemSubtypeEnum["Data"] = "data";
    })(ItemSubtypeEnum = LinkedItem.ItemSubtypeEnum || (LinkedItem.ItemSubtypeEnum = {}));
})(LinkedItem || (exports.LinkedItem = LinkedItem = {}));
/**
 * @export
 * @namespace ManifestKeypadNumbers
 */
var ManifestKeypadNumbers;
(function (ManifestKeypadNumbers) {
    /**
     * @export
     * @enum {string}
     */
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum["Collection"] = "collection";
        ItemTypeEnum["Screen"] = "screen";
    })(ItemTypeEnum = ManifestKeypadNumbers.ItemTypeEnum || (ManifestKeypadNumbers.ItemTypeEnum = {}));
})(ManifestKeypadNumbers || (exports.ManifestKeypadNumbers = ManifestKeypadNumbers = {}));
/**
 * @export
 * @namespace MapItem
 */
var MapItem;
(function (MapItem) {
    /**
     * @export
     * @enum {string}
     */
    var StockIconPinStyleEnum;
    (function (StockIconPinStyleEnum) {
        StockIconPinStyleEnum["Default"] = "default";
        StockIconPinStyleEnum["Regular"] = "regular";
        StockIconPinStyleEnum["Brands"] = "brands";
        StockIconPinStyleEnum["Duotone"] = "duotone";
        StockIconPinStyleEnum["Light"] = "light";
        StockIconPinStyleEnum["Solid"] = "solid";
    })(StockIconPinStyleEnum = MapItem.StockIconPinStyleEnum || (MapItem.StockIconPinStyleEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum["Collection"] = "collection";
        ItemTypeEnum["CollectionItem"] = "collection_item";
        ItemTypeEnum["Screen"] = "screen";
        ItemTypeEnum["MediaItem"] = "media_item";
    })(ItemTypeEnum = MapItem.ItemTypeEnum || (MapItem.ItemTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var LinkTypeEnum;
    (function (LinkTypeEnum) {
        LinkTypeEnum["Twitter"] = "twitter";
        LinkTypeEnum["Whatsapp"] = "whatsapp";
        LinkTypeEnum["Wechat"] = "wechat";
        LinkTypeEnum["Facebook"] = "facebook";
        LinkTypeEnum["Instagram"] = "instagram";
        LinkTypeEnum["Pinterest"] = "pinterest";
        LinkTypeEnum["Youtube"] = "youtube";
        LinkTypeEnum["Vimeo"] = "vimeo";
        LinkTypeEnum["Linkedin"] = "linkedin";
        LinkTypeEnum["Tiktok"] = "tiktok";
        LinkTypeEnum["Weibo"] = "weibo";
        LinkTypeEnum["Bluesky"] = "bluesky";
        LinkTypeEnum["Internal"] = "internal";
        LinkTypeEnum["Url"] = "url";
        LinkTypeEnum["Email"] = "email";
        LinkTypeEnum["Phone"] = "phone";
        LinkTypeEnum["LiveTours"] = "live_tours";
        LinkTypeEnum["Settings"] = "settings";
        LinkTypeEnum["Badges"] = "badges";
        LinkTypeEnum["Favourites"] = "favourites";
        LinkTypeEnum["Download"] = "download";
        LinkTypeEnum["AppRating"] = "app_rating";
    })(LinkTypeEnum = MapItem.LinkTypeEnum || (MapItem.LinkTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ItemSubtypeEnum;
    (function (ItemSubtypeEnum) {
        ItemSubtypeEnum["CollectionList"] = "collection_list";
        ItemSubtypeEnum["CollectionTour"] = "collection_tour";
        ItemSubtypeEnum["CollectionOrganization"] = "collection_organization";
        ItemSubtypeEnum["CollectionMenu"] = "collection_menu";
        ItemSubtypeEnum["CollectionSearch"] = "collection_search";
        ItemSubtypeEnum["ScreenStory"] = "screen_story";
        ItemSubtypeEnum["ScreenWeb"] = "screen_web";
        ItemSubtypeEnum["ScreenPanorama"] = "screen_panorama";
        ItemSubtypeEnum["ScreenAr"] = "screen_ar";
        ItemSubtypeEnum["ScreenKiosk"] = "screen_kiosk";
    })(ItemSubtypeEnum = MapItem.ItemSubtypeEnum || (MapItem.ItemSubtypeEnum = {}));
})(MapItem || (exports.MapItem = MapItem = {}));
/**
 * @export
 * @namespace MapRoute
 */
var MapRoute;
(function (MapRoute) {
    /**
     * @export
     * @enum {string}
     */
    var LinkedTypeEnum;
    (function (LinkedTypeEnum) {
        LinkedTypeEnum["Collection"] = "Collection";
        LinkedTypeEnum["StorySection"] = "StorySection";
    })(LinkedTypeEnum = MapRoute.LinkedTypeEnum || (MapRoute.LinkedTypeEnum = {}));
})(MapRoute || (exports.MapRoute = MapRoute = {}));
/**
 * @export
 * @namespace MediaItem
 */
var MediaItem;
(function (MediaItem) {
    /**
     * @export
     * @enum {string}
     */
    var RemoteTypeEnum;
    (function (RemoteTypeEnum) {
        RemoteTypeEnum["Youtube"] = "youtube";
        RemoteTypeEnum["Vimeo"] = "vimeo";
    })(RemoteTypeEnum = MediaItem.RemoteTypeEnum || (MediaItem.RemoteTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MediaTypeEnum;
    (function (MediaTypeEnum) {
        MediaTypeEnum["Map"] = "map";
        MediaTypeEnum["Webpackage"] = "webpackage";
        MediaTypeEnum["Animation"] = "animation";
        MediaTypeEnum["Audio"] = "audio";
        MediaTypeEnum["Image"] = "image";
        MediaTypeEnum["Video"] = "video";
        MediaTypeEnum["Webvideo"] = "webvideo";
        MediaTypeEnum["Ar"] = "ar";
        MediaTypeEnum["Data"] = "data";
    })(MediaTypeEnum = MediaItem.MediaTypeEnum || (MediaItem.MediaTypeEnum = {}));
})(MediaItem || (exports.MediaItem = MediaItem = {}));
/**
 * @export
 * @namespace Order
 */
var Order;
(function (Order) {
    /**
     * @export
     * @enum {string}
     */
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum["Stripe"] = "stripe";
        OrderTypeEnum["AppStore"] = "app_store";
        OrderTypeEnum["PlayStore"] = "play_store";
    })(OrderTypeEnum = Order.OrderTypeEnum || (Order.OrderTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum["Started"] = "started";
        StatusEnum["Error"] = "error";
        StatusEnum["Processing"] = "processing";
        StatusEnum["Succeeded"] = "succeeded";
        StatusEnum["Failed"] = "failed";
    })(StatusEnum = Order.StatusEnum || (Order.StatusEnum = {}));
})(Order || (exports.Order = Order = {}));
/**
 * @export
 * @namespace OrderItem
 */
var OrderItem;
(function (OrderItem) {
    /**
     * @export
     * @enum {string}
     */
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum["Collection"] = "Collection";
        ItemTypeEnum["Screen"] = "Screen";
        ItemTypeEnum["Project"] = "Project";
        ItemTypeEnum["Bundle"] = "Bundle";
    })(ItemTypeEnum = OrderItem.ItemTypeEnum || (OrderItem.ItemTypeEnum = {}));
})(OrderItem || (exports.OrderItem = OrderItem = {}));
/**
 * @export
 * @namespace Placement
 */
var Placement;
(function (Placement) {
    /**
     * @export
     * @enum {string}
     */
    var XUnitEnum;
    (function (XUnitEnum) {
        XUnitEnum["Pixels"] = "pixels";
        XUnitEnum["Percent"] = "percent";
    })(XUnitEnum = Placement.XUnitEnum || (Placement.XUnitEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var YUnitEnum;
    (function (YUnitEnum) {
        YUnitEnum["Pixels"] = "pixels";
        YUnitEnum["Percent"] = "percent";
    })(YUnitEnum = Placement.YUnitEnum || (Placement.YUnitEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var WUnitEnum;
    (function (WUnitEnum) {
        WUnitEnum["Pixels"] = "pixels";
        WUnitEnum["Percent"] = "percent";
    })(WUnitEnum = Placement.WUnitEnum || (Placement.WUnitEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var HUnitEnum;
    (function (HUnitEnum) {
        HUnitEnum["Pixels"] = "pixels";
        HUnitEnum["Percent"] = "percent";
    })(HUnitEnum = Placement.HUnitEnum || (Placement.HUnitEnum = {}));
})(Placement || (exports.Placement = Placement = {}));
/**
 * @export
 * @namespace ProjectAppProjectFeatures
 */
var ProjectAppProjectFeatures;
(function (ProjectAppProjectFeatures) {
    /**
     * @export
     * @enum {string}
     */
    var AllowDownloadEnum;
    (function (AllowDownloadEnum) {
        AllowDownloadEnum["Disabled"] = "disabled";
        AllowDownloadEnum["Optional"] = "optional";
        AllowDownloadEnum["Forced"] = "forced";
        AllowDownloadEnum["ForcedNative"] = "forced_native";
    })(AllowDownloadEnum = ProjectAppProjectFeatures.AllowDownloadEnum || (ProjectAppProjectFeatures.AllowDownloadEnum = {}));
})(ProjectAppProjectFeatures || (exports.ProjectAppProjectFeatures = ProjectAppProjectFeatures = {}));
/**
 * @export
 * @namespace ProjectKioskProjectFeatures
 */
var ProjectKioskProjectFeatures;
(function (ProjectKioskProjectFeatures) {
    /**
     * @export
     * @enum {string}
     */
    var BackButtonLocationEnum;
    (function (BackButtonLocationEnum) {
        BackButtonLocationEnum["TopLeft"] = "top_left";
        BackButtonLocationEnum["TopRight"] = "top_right";
        BackButtonLocationEnum["TopCenter"] = "top_center";
        BackButtonLocationEnum["BottomLeft"] = "bottom_left";
        BackButtonLocationEnum["BottomRight"] = "bottom_right";
        BackButtonLocationEnum["BottomCenter"] = "bottom_center";
        BackButtonLocationEnum["Hidden"] = "hidden";
    })(BackButtonLocationEnum = ProjectKioskProjectFeatures.BackButtonLocationEnum || (ProjectKioskProjectFeatures.BackButtonLocationEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var LanguageSwitcherLocationEnum;
    (function (LanguageSwitcherLocationEnum) {
        LanguageSwitcherLocationEnum["TopLeft"] = "top_left";
        LanguageSwitcherLocationEnum["TopRight"] = "top_right";
        LanguageSwitcherLocationEnum["TopCenter"] = "top_center";
        LanguageSwitcherLocationEnum["BottomLeft"] = "bottom_left";
        LanguageSwitcherLocationEnum["BottomRight"] = "bottom_right";
        LanguageSwitcherLocationEnum["BottomCenter"] = "bottom_center";
        LanguageSwitcherLocationEnum["Hidden"] = "hidden";
    })(LanguageSwitcherLocationEnum = ProjectKioskProjectFeatures.LanguageSwitcherLocationEnum || (ProjectKioskProjectFeatures.LanguageSwitcherLocationEnum = {}));
})(ProjectKioskProjectFeatures || (exports.ProjectKioskProjectFeatures = ProjectKioskProjectFeatures = {}));
/**
 * @export
 * @namespace Question
 */
var Question;
(function (Question) {
    /**
     * @export
     * @enum {string}
     */
    var QuestionTypeEnum;
    (function (QuestionTypeEnum) {
        QuestionTypeEnum["SingleTextChoice"] = "single_text_choice";
        QuestionTypeEnum["SingleImageChoice"] = "single_image_choice";
        QuestionTypeEnum["MultiTextChoice"] = "multi_text_choice";
        QuestionTypeEnum["MultiImageChoice"] = "multi_image_choice";
        QuestionTypeEnum["FreeText"] = "free_text";
    })(QuestionTypeEnum = Question.QuestionTypeEnum || (Question.QuestionTypeEnum = {}));
})(Question || (exports.Question = Question = {}));
/**
 * @export
 * @namespace RedeemCode
 */
var RedeemCode;
(function (RedeemCode) {
    /**
     * @export
     * @enum {string}
     */
    var LinkedTypeEnum;
    (function (LinkedTypeEnum) {
        LinkedTypeEnum["App"] = "App";
        LinkedTypeEnum["Project"] = "Project";
        LinkedTypeEnum["Collection"] = "Collection";
    })(LinkedTypeEnum = RedeemCode.LinkedTypeEnum || (RedeemCode.LinkedTypeEnum = {}));
})(RedeemCode || (exports.RedeemCode = RedeemCode = {}));
/**
 * @export
 * @namespace RedeemCodeResponse
 */
var RedeemCodeResponse;
(function (RedeemCodeResponse) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum["Expired"] = "expired";
        StatusEnum["Future"] = "future";
        StatusEnum["Valid"] = "valid";
        StatusEnum["Invalid"] = "invalid";
        StatusEnum["CollectionUnlocked"] = "collection_unlocked";
        StatusEnum["Current"] = "current";
        StatusEnum["MaxRedemptions"] = "max_redemptions";
        StatusEnum["RequiresEmail"] = "requires_email";
    })(StatusEnum = RedeemCodeResponse.StatusEnum || (RedeemCodeResponse.StatusEnum = {}));
})(RedeemCodeResponse || (exports.RedeemCodeResponse = RedeemCodeResponse = {}));
/**
 * @export
 * @namespace Trigger
 */
var Trigger;
(function (Trigger) {
    /**
     * @export
     * @enum {string}
     */
    var TriggerTypeEnum;
    (function (TriggerTypeEnum) {
        TriggerTypeEnum["Off"] = "off";
        TriggerTypeEnum["QuizQuestion"] = "quiz_question";
        TriggerTypeEnum["Screen"] = "screen";
        TriggerTypeEnum["Gps"] = "gps";
        TriggerTypeEnum["Beacon"] = "beacon";
    })(TriggerTypeEnum = Trigger.TriggerTypeEnum || (Trigger.TriggerTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TriggerableTypeEnum;
    (function (TriggerableTypeEnum) {
        TriggerableTypeEnum["QuizQuestion"] = "QuizQuestion";
        TriggerableTypeEnum["Screen"] = "Screen";
    })(TriggerableTypeEnum = Trigger.TriggerableTypeEnum || (Trigger.TriggerableTypeEnum = {}));
})(Trigger || (exports.Trigger = Trigger = {}));
/**
 * @export
 * @namespace ValidateCodeResponse
 */
var ValidateCodeResponse;
(function (ValidateCodeResponse) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum["Expired"] = "expired";
        StatusEnum["Future"] = "future";
        StatusEnum["Valid"] = "valid";
        StatusEnum["Invalid"] = "invalid";
        StatusEnum["CollectionUnlocked"] = "collection_unlocked";
        StatusEnum["Current"] = "current";
        StatusEnum["MaxRedemptions"] = "max_redemptions";
        StatusEnum["RequiresEmail"] = "requires_email";
    })(StatusEnum = ValidateCodeResponse.StatusEnum || (ValidateCodeResponse.StatusEnum = {}));
})(ValidateCodeResponse || (exports.ValidateCodeResponse = ValidateCodeResponse = {}));
/**
 * @export
 * @namespace ValidateToken
 */
var ValidateToken;
(function (ValidateToken) {
    /**
     * @export
     * @enum {string}
     */
    var TokenTypeEnum;
    (function (TokenTypeEnum) {
        TokenTypeEnum["App"] = "app";
        TokenTypeEnum["Demo"] = "demo";
        TokenTypeEnum["MobileWeb"] = "mobile_web";
        TokenTypeEnum["RentalMode"] = "rental_mode";
        TokenTypeEnum["Kiosk"] = "kiosk";
        TokenTypeEnum["LegacyApp"] = "legacy_app";
    })(TokenTypeEnum = ValidateToken.TokenTypeEnum || (ValidateToken.TokenTypeEnum = {}));
})(ValidateToken || (exports.ValidateToken = ValidateToken = {}));
/**
 * ImagesApi - fetch parameter creator
 * @export
 */
var ImagesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'app_id' is not null or undefined
            if (app_id === null || app_id === undefined) {
                throw new RequiredError('app_id', 'Required parameter app_id was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'tab_id' is not null or undefined
            if (tab_id === null || tab_id === undefined) {
                throw new RequiredError('tab_id', 'Required parameter tab_id was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'collection_id' is not null or undefined
            if (collection_id === null || collection_id === undefined) {
                throw new RequiredError('collection_id', 'Required parameter collection_id was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'collection_item_id' is not null or undefined
            if (collection_item_id === null || collection_item_id === undefined) {
                throw new RequiredError('collection_item_id', 'Required parameter collection_item_id was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size', 'Required parameter size was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'color' is not null or undefined
            if (color === null || color === undefined) {
                throw new RequiredError('color', 'Required parameter color was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'body_shape' is not null or undefined
            if (body_shape === null || body_shape === undefined) {
                throw new RequiredError('body_shape', 'Required parameter body_shape was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'level' is not null or undefined
            if (level === null || level === undefined) {
                throw new RequiredError('level', 'Required parameter level was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'background' is not null or undefined
            if (background === null || background === undefined) {
                throw new RequiredError('background', 'Required parameter background was null or undefined when calling imageQRShow.');
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError('format', 'Required parameter format was null or undefined when calling imageQRShow.');
            }
            var localVarPath = "/api/v3/images/qr/{app_id}/collection/{collection_id}/{size}/{color}/{body_shape}/{level}/{background(:format)}"
                .replace("{".concat("app_id", "}"), encodeURIComponent(String(app_id)))
                .replace("{".concat("tab_id", "}"), encodeURIComponent(String(tab_id)))
                .replace("{".concat("collection_id", "}"), encodeURIComponent(String(collection_id)))
                .replace("{".concat("collection_item_id", "}"), encodeURIComponent(String(collection_item_id)))
                .replace("{".concat("size", "}"), encodeURIComponent(String(size)))
                .replace("{".concat("color", "}"), encodeURIComponent(String(color)))
                .replace("{".concat("body_shape", "}"), encodeURIComponent(String(body_shape)))
                .replace("{".concat("level", "}"), encodeURIComponent(String(level)))
                .replace("{".concat("background", "}"), encodeURIComponent(String(background)))
                .replace("{".concat("format", "}"), encodeURIComponent(String(format)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_1: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'app_id' is not null or undefined
            if (app_id === null || app_id === undefined) {
                throw new RequiredError('app_id', 'Required parameter app_id was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'tab_id' is not null or undefined
            if (tab_id === null || tab_id === undefined) {
                throw new RequiredError('tab_id', 'Required parameter tab_id was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'collection_id' is not null or undefined
            if (collection_id === null || collection_id === undefined) {
                throw new RequiredError('collection_id', 'Required parameter collection_id was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'collection_item_id' is not null or undefined
            if (collection_item_id === null || collection_item_id === undefined) {
                throw new RequiredError('collection_item_id', 'Required parameter collection_item_id was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size', 'Required parameter size was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'color' is not null or undefined
            if (color === null || color === undefined) {
                throw new RequiredError('color', 'Required parameter color was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'body_shape' is not null or undefined
            if (body_shape === null || body_shape === undefined) {
                throw new RequiredError('body_shape', 'Required parameter body_shape was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'level' is not null or undefined
            if (level === null || level === undefined) {
                throw new RequiredError('level', 'Required parameter level was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'background' is not null or undefined
            if (background === null || background === undefined) {
                throw new RequiredError('background', 'Required parameter background was null or undefined when calling imageQRShow_1.');
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError('format', 'Required parameter format was null or undefined when calling imageQRShow_1.');
            }
            var localVarPath = "/api/v3/images/qr/{app_id}/collection_item/{collection_item_id}/{size}/{color}/{body_shape}/{level}/{background(:format)}"
                .replace("{".concat("app_id", "}"), encodeURIComponent(String(app_id)))
                .replace("{".concat("tab_id", "}"), encodeURIComponent(String(tab_id)))
                .replace("{".concat("collection_id", "}"), encodeURIComponent(String(collection_id)))
                .replace("{".concat("collection_item_id", "}"), encodeURIComponent(String(collection_item_id)))
                .replace("{".concat("size", "}"), encodeURIComponent(String(size)))
                .replace("{".concat("color", "}"), encodeURIComponent(String(color)))
                .replace("{".concat("body_shape", "}"), encodeURIComponent(String(body_shape)))
                .replace("{".concat("level", "}"), encodeURIComponent(String(level)))
                .replace("{".concat("background", "}"), encodeURIComponent(String(background)))
                .replace("{".concat("format", "}"), encodeURIComponent(String(format)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_2: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'app_id' is not null or undefined
            if (app_id === null || app_id === undefined) {
                throw new RequiredError('app_id', 'Required parameter app_id was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'tab_id' is not null or undefined
            if (tab_id === null || tab_id === undefined) {
                throw new RequiredError('tab_id', 'Required parameter tab_id was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'collection_id' is not null or undefined
            if (collection_id === null || collection_id === undefined) {
                throw new RequiredError('collection_id', 'Required parameter collection_id was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'collection_item_id' is not null or undefined
            if (collection_item_id === null || collection_item_id === undefined) {
                throw new RequiredError('collection_item_id', 'Required parameter collection_item_id was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size', 'Required parameter size was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'color' is not null or undefined
            if (color === null || color === undefined) {
                throw new RequiredError('color', 'Required parameter color was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'body_shape' is not null or undefined
            if (body_shape === null || body_shape === undefined) {
                throw new RequiredError('body_shape', 'Required parameter body_shape was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'level' is not null or undefined
            if (level === null || level === undefined) {
                throw new RequiredError('level', 'Required parameter level was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'background' is not null or undefined
            if (background === null || background === undefined) {
                throw new RequiredError('background', 'Required parameter background was null or undefined when calling imageQRShow_2.');
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError('format', 'Required parameter format was null or undefined when calling imageQRShow_2.');
            }
            var localVarPath = "/api/v3/images/qr/{app_id}/linked_item/{linked_item_id}/{size}/{color}/{body_shape}/{level}/{background(:format)}"
                .replace("{".concat("app_id", "}"), encodeURIComponent(String(app_id)))
                .replace("{".concat("tab_id", "}"), encodeURIComponent(String(tab_id)))
                .replace("{".concat("collection_id", "}"), encodeURIComponent(String(collection_id)))
                .replace("{".concat("collection_item_id", "}"), encodeURIComponent(String(collection_item_id)))
                .replace("{".concat("size", "}"), encodeURIComponent(String(size)))
                .replace("{".concat("color", "}"), encodeURIComponent(String(color)))
                .replace("{".concat("body_shape", "}"), encodeURIComponent(String(body_shape)))
                .replace("{".concat("level", "}"), encodeURIComponent(String(level)))
                .replace("{".concat("background", "}"), encodeURIComponent(String(background)))
                .replace("{".concat("format", "}"), encodeURIComponent(String(format)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_3: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'app_id' is not null or undefined
            if (app_id === null || app_id === undefined) {
                throw new RequiredError('app_id', 'Required parameter app_id was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'tab_id' is not null or undefined
            if (tab_id === null || tab_id === undefined) {
                throw new RequiredError('tab_id', 'Required parameter tab_id was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'collection_id' is not null or undefined
            if (collection_id === null || collection_id === undefined) {
                throw new RequiredError('collection_id', 'Required parameter collection_id was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'collection_item_id' is not null or undefined
            if (collection_item_id === null || collection_item_id === undefined) {
                throw new RequiredError('collection_item_id', 'Required parameter collection_item_id was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size', 'Required parameter size was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'color' is not null or undefined
            if (color === null || color === undefined) {
                throw new RequiredError('color', 'Required parameter color was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'body_shape' is not null or undefined
            if (body_shape === null || body_shape === undefined) {
                throw new RequiredError('body_shape', 'Required parameter body_shape was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'level' is not null or undefined
            if (level === null || level === undefined) {
                throw new RequiredError('level', 'Required parameter level was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'background' is not null or undefined
            if (background === null || background === undefined) {
                throw new RequiredError('background', 'Required parameter background was null or undefined when calling imageQRShow_3.');
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError('format', 'Required parameter format was null or undefined when calling imageQRShow_3.');
            }
            var localVarPath = "/api/v3/images/qr/{app_id}/screen/{screen_id}/{size}/{color}/{body_shape}/{level}/{background(:format)}"
                .replace("{".concat("app_id", "}"), encodeURIComponent(String(app_id)))
                .replace("{".concat("tab_id", "}"), encodeURIComponent(String(tab_id)))
                .replace("{".concat("collection_id", "}"), encodeURIComponent(String(collection_id)))
                .replace("{".concat("collection_item_id", "}"), encodeURIComponent(String(collection_item_id)))
                .replace("{".concat("size", "}"), encodeURIComponent(String(size)))
                .replace("{".concat("color", "}"), encodeURIComponent(String(color)))
                .replace("{".concat("body_shape", "}"), encodeURIComponent(String(body_shape)))
                .replace("{".concat("level", "}"), encodeURIComponent(String(level)))
                .replace("{".concat("background", "}"), encodeURIComponent(String(background)))
                .replace("{".concat("format", "}"), encodeURIComponent(String(format)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_4: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'app_id' is not null or undefined
            if (app_id === null || app_id === undefined) {
                throw new RequiredError('app_id', 'Required parameter app_id was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'tab_id' is not null or undefined
            if (tab_id === null || tab_id === undefined) {
                throw new RequiredError('tab_id', 'Required parameter tab_id was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'collection_id' is not null or undefined
            if (collection_id === null || collection_id === undefined) {
                throw new RequiredError('collection_id', 'Required parameter collection_id was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'collection_item_id' is not null or undefined
            if (collection_item_id === null || collection_item_id === undefined) {
                throw new RequiredError('collection_item_id', 'Required parameter collection_item_id was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size', 'Required parameter size was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'color' is not null or undefined
            if (color === null || color === undefined) {
                throw new RequiredError('color', 'Required parameter color was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'body_shape' is not null or undefined
            if (body_shape === null || body_shape === undefined) {
                throw new RequiredError('body_shape', 'Required parameter body_shape was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'level' is not null or undefined
            if (level === null || level === undefined) {
                throw new RequiredError('level', 'Required parameter level was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'background' is not null or undefined
            if (background === null || background === undefined) {
                throw new RequiredError('background', 'Required parameter background was null or undefined when calling imageQRShow_4.');
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError('format', 'Required parameter format was null or undefined when calling imageQRShow_4.');
            }
            var localVarPath = "/api/v3/images/qr/{app_id}/tab/{tab_id}/{size}/{color}/{body_shape}/{level}/{background(:format)}"
                .replace("{".concat("app_id", "}"), encodeURIComponent(String(app_id)))
                .replace("{".concat("tab_id", "}"), encodeURIComponent(String(tab_id)))
                .replace("{".concat("collection_id", "}"), encodeURIComponent(String(collection_id)))
                .replace("{".concat("collection_item_id", "}"), encodeURIComponent(String(collection_item_id)))
                .replace("{".concat("size", "}"), encodeURIComponent(String(size)))
                .replace("{".concat("color", "}"), encodeURIComponent(String(color)))
                .replace("{".concat("body_shape", "}"), encodeURIComponent(String(body_shape)))
                .replace("{".concat("level", "}"), encodeURIComponent(String(level)))
                .replace("{".concat("background", "}"), encodeURIComponent(String(background)))
                .replace("{".concat("format", "}"), encodeURIComponent(String(format)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_5: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'app_id' is not null or undefined
            if (app_id === null || app_id === undefined) {
                throw new RequiredError('app_id', 'Required parameter app_id was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'tab_id' is not null or undefined
            if (tab_id === null || tab_id === undefined) {
                throw new RequiredError('tab_id', 'Required parameter tab_id was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'collection_id' is not null or undefined
            if (collection_id === null || collection_id === undefined) {
                throw new RequiredError('collection_id', 'Required parameter collection_id was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'collection_item_id' is not null or undefined
            if (collection_item_id === null || collection_item_id === undefined) {
                throw new RequiredError('collection_item_id', 'Required parameter collection_item_id was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size', 'Required parameter size was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'color' is not null or undefined
            if (color === null || color === undefined) {
                throw new RequiredError('color', 'Required parameter color was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'body_shape' is not null or undefined
            if (body_shape === null || body_shape === undefined) {
                throw new RequiredError('body_shape', 'Required parameter body_shape was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'level' is not null or undefined
            if (level === null || level === undefined) {
                throw new RequiredError('level', 'Required parameter level was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'background' is not null or undefined
            if (background === null || background === undefined) {
                throw new RequiredError('background', 'Required parameter background was null or undefined when calling imageQRShow_5.');
            }
            // verify required parameter 'format' is not null or undefined
            if (format === null || format === undefined) {
                throw new RequiredError('format', 'Required parameter format was null or undefined when calling imageQRShow_5.');
            }
            var localVarPath = "/api/v3/images/qr/{app_id}/{size}/{color}/{body_shape}/{level}/{background(:format)}"
                .replace("{".concat("app_id", "}"), encodeURIComponent(String(app_id)))
                .replace("{".concat("tab_id", "}"), encodeURIComponent(String(tab_id)))
                .replace("{".concat("collection_id", "}"), encodeURIComponent(String(collection_id)))
                .replace("{".concat("collection_item_id", "}"), encodeURIComponent(String(collection_item_id)))
                .replace("{".concat("size", "}"), encodeURIComponent(String(size)))
                .replace("{".concat("color", "}"), encodeURIComponent(String(color)))
                .replace("{".concat("body_shape", "}"), encodeURIComponent(String(body_shape)))
                .replace("{".concat("level", "}"), encodeURIComponent(String(level)))
                .replace("{".concat("background", "}"), encodeURIComponent(String(background)))
                .replace("{".concat("format", "}"), encodeURIComponent(String(format)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ImagesApiFetchParamCreator = ImagesApiFetchParamCreator;
/**
 * ImagesApi - functional programming interface
 * @export
 */
var ImagesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            var localVarFetchArgs = (0, exports.ImagesApiFetchParamCreator)(configuration).imageQRShow(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_1: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            var localVarFetchArgs = (0, exports.ImagesApiFetchParamCreator)(configuration).imageQRShow_1(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_2: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            var localVarFetchArgs = (0, exports.ImagesApiFetchParamCreator)(configuration).imageQRShow_2(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_3: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            var localVarFetchArgs = (0, exports.ImagesApiFetchParamCreator)(configuration).imageQRShow_3(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_4: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            var localVarFetchArgs = (0, exports.ImagesApiFetchParamCreator)(configuration).imageQRShow_4(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_5: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            var localVarFetchArgs = (0, exports.ImagesApiFetchParamCreator)(configuration).imageQRShow_5(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ImagesApiFp = ImagesApiFp;
/**
 * ImagesApi - factory interface
 * @export
 */
var ImagesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            return (0, exports.ImagesApiFp)(configuration).imageQRShow(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_1: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            return (0, exports.ImagesApiFp)(configuration).imageQRShow_1(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_2: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            return (0, exports.ImagesApiFp)(configuration).imageQRShow_2(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_3: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            return (0, exports.ImagesApiFp)(configuration).imageQRShow_3(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_4: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            return (0, exports.ImagesApiFp)(configuration).imageQRShow_4(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets a QR code image for an app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} app_id App ID
         * @param {number} tab_id Tab ID
         * @param {number} collection_id Collection ID
         * @param {number} collection_item_id Collection Item ID
         * @param {number} size Size in pixels
         * @param {string} color Hex colour of the QR Code
         * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
         * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
         * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
         * @param {string} format Format of response
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageQRShow_5: function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
            return (0, exports.ImagesApiFp)(configuration).imageQRShow_5(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(fetch, basePath);
        },
    };
};
exports.ImagesApiFactory = ImagesApiFactory;
/**
 * ImagesApi - object-oriented interface
 * @export
 * @class ImagesApi
 * @extends {BaseAPI}
 */
var ImagesApi = /** @class */ (function (_super) {
    __extends(ImagesApi, _super);
    function ImagesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary This API gets a QR code image for an app
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} app_id App ID
     * @param {number} tab_id Tab ID
     * @param {number} collection_id Collection ID
     * @param {number} collection_item_id Collection Item ID
     * @param {number} size Size in pixels
     * @param {string} color Hex colour of the QR Code
     * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
     * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
     * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
     * @param {string} format Format of response
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    ImagesApi.prototype.imageQRShow = function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
        return (0, exports.ImagesApiFp)(this.configuration).imageQRShow(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets a QR code image for an app
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} app_id App ID
     * @param {number} tab_id Tab ID
     * @param {number} collection_id Collection ID
     * @param {number} collection_item_id Collection Item ID
     * @param {number} size Size in pixels
     * @param {string} color Hex colour of the QR Code
     * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
     * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
     * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
     * @param {string} format Format of response
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    ImagesApi.prototype.imageQRShow_1 = function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
        return (0, exports.ImagesApiFp)(this.configuration).imageQRShow_1(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets a QR code image for an app
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} app_id App ID
     * @param {number} tab_id Tab ID
     * @param {number} collection_id Collection ID
     * @param {number} collection_item_id Collection Item ID
     * @param {number} size Size in pixels
     * @param {string} color Hex colour of the QR Code
     * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
     * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
     * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
     * @param {string} format Format of response
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    ImagesApi.prototype.imageQRShow_2 = function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
        return (0, exports.ImagesApiFp)(this.configuration).imageQRShow_2(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets a QR code image for an app
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} app_id App ID
     * @param {number} tab_id Tab ID
     * @param {number} collection_id Collection ID
     * @param {number} collection_item_id Collection Item ID
     * @param {number} size Size in pixels
     * @param {string} color Hex colour of the QR Code
     * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
     * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
     * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
     * @param {string} format Format of response
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    ImagesApi.prototype.imageQRShow_3 = function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
        return (0, exports.ImagesApiFp)(this.configuration).imageQRShow_3(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets a QR code image for an app
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} app_id App ID
     * @param {number} tab_id Tab ID
     * @param {number} collection_id Collection ID
     * @param {number} collection_item_id Collection Item ID
     * @param {number} size Size in pixels
     * @param {string} color Hex colour of the QR Code
     * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
     * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
     * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
     * @param {string} format Format of response
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    ImagesApi.prototype.imageQRShow_4 = function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
        return (0, exports.ImagesApiFp)(this.configuration).imageQRShow_4(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets a QR code image for an app
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} app_id App ID
     * @param {number} tab_id Tab ID
     * @param {number} collection_id Collection ID
     * @param {number} collection_item_id Collection Item ID
     * @param {number} size Size in pixels
     * @param {string} color Hex colour of the QR Code
     * @param {string} body_shape Shape of the body items, not currently implemented but you need to send it
     * @param {string} level Quality/level of QR Code - l: 7% of the code can be restored, m: 15%, q: 25%, h: 30%
     * @param {number} background Media Item ID to set in the middle, send &#39;q&#39; for STQRY Q logo, &#39;none&#39; for none
     * @param {string} format Format of response
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    ImagesApi.prototype.imageQRShow_5 = function (device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options) {
        return (0, exports.ImagesApiFp)(this.configuration).imageQRShow_5(device_platform, app_id, tab_id, collection_id, collection_item_id, size, color, body_shape, level, background, format, device_udid, options)(this.fetch, this.basePath);
    };
    return ImagesApi;
}(BaseAPI));
exports.ImagesApi = ImagesApi;
/**
 * MytoursApi - fetch parameter creator
 * @export
 */
var MytoursApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary This API gets the manifest for the whole app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appManifest: function (device_platform, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling appManifest.');
            }
            var localVarPath = "/api/v3/app/manifest";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the top level app metadata
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appShow: function (device_platform, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling appShow.');
            }
            var localVarPath = "/api/v3/app";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the UUID for the whole app
         * @param {number} id The app ID to return
         * @param {ValidateToken} [validate_token] Validate app token with short token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appToken: function (id, validate_token, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling appToken.');
            }
            var localVarPath = "/api/v3/app/token/{id}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ValidateToken" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(validate_token || {}) : (validate_token || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the information for an individual badge group (includes the badges and triggers)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeGroupsShow: function (device_platform, id, version, language, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling badgeGroupsShow.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling badgeGroupsShow.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling badgeGroupsShow.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling badgeGroupsShow.');
            }
            var localVarPath = "/api/v3/badge_groups/{id}/{language}/{version}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the collection items for an individual collection
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionItemsIndex: function (device_platform, id, version, language, device_udid, page, per_page, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling collectionItemsIndex.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling collectionItemsIndex.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling collectionItemsIndex.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling collectionItemsIndex.');
            }
            var localVarPath = "/api/v3/collections/{id}/items/{language}/{version}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (per_page !== undefined) {
                localVarQueryParameter['per_page'] = per_page;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the manifest for a collection
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionManifest: function (device_platform, id, version, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling collectionManifest.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling collectionManifest.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling collectionManifest.');
            }
            var localVarPath = "/api/v3/collections/{id}/manifest"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the collection triggers for an individual collection
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionTriggersIndex: function (id, version, language, page, per_page, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling collectionTriggersIndex.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling collectionTriggersIndex.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling collectionTriggersIndex.');
            }
            var localVarPath = "/api/v3/collections/{id}/triggers/{language}/{version}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (per_page !== undefined) {
                localVarQueryParameter['per_page'] = per_page;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the information for an individual collection (excludes the items)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionsShow: function (device_platform, id, version, language, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling collectionsShow.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling collectionsShow.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling collectionsShow.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling collectionsShow.');
            }
            var localVarPath = "/api/v3/collections/{id}/{language}/{version}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the information for a CustomWidget
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id ID of CustomWidget to show
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customWidgetShow: function (device_platform, id, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling customWidgetShow.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling customWidgetShow.');
            }
            var localVarPath = "/api/v3/custom_widgets/{id}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the top level Project metadata for a display
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} uuid The display UUID to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        displayShow: function (device_platform, uuid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling displayShow.');
            }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid', 'Required parameter uuid was null or undefined when calling displayShow.');
            }
            var localVarPath = "/api/v3/display/{uuid}"
                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets an individual form
         * @param {number} id ID of Form to show
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formShow: function (id, version, language, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling formShow.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling formShow.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling formShow.');
            }
            var localVarPath = "/api/v3/forms/{id}/{language}/{version}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API submits a form
         * @param {number} id ID of Form to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSubmit: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling formSubmit.');
            }
            var localVarPath = "/api/v3/forms/{id}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets an icon image
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} style Style of icon
         * @param {string} icon Icon name use. Use &#39;default&#39;, &#39;visited&#39; and &#39;active&#39; for our default pins
         * @param {string} colour Hex code (without #) to make the pin. Default defaults to STQRY colour
         * @param {number} width Width in pixels
         * @param {number} height Height in pixels
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageIconShow: function (device_platform, style, icon, colour, width, height, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling imageIconShow.');
            }
            // verify required parameter 'style' is not null or undefined
            if (style === null || style === undefined) {
                throw new RequiredError('style', 'Required parameter style was null or undefined when calling imageIconShow.');
            }
            // verify required parameter 'icon' is not null or undefined
            if (icon === null || icon === undefined) {
                throw new RequiredError('icon', 'Required parameter icon was null or undefined when calling imageIconShow.');
            }
            // verify required parameter 'colour' is not null or undefined
            if (colour === null || colour === undefined) {
                throw new RequiredError('colour', 'Required parameter colour was null or undefined when calling imageIconShow.');
            }
            // verify required parameter 'width' is not null or undefined
            if (width === null || width === undefined) {
                throw new RequiredError('width', 'Required parameter width was null or undefined when calling imageIconShow.');
            }
            // verify required parameter 'height' is not null or undefined
            if (height === null || height === undefined) {
                throw new RequiredError('height', 'Required parameter height was null or undefined when calling imageIconShow.');
            }
            var localVarPath = "/api/v3/images/icon/{style}/{colour}/{icon}/{width}/{height(.png)}"
                .replace("{".concat("style", "}"), encodeURIComponent(String(style)))
                .replace("{".concat("icon", "}"), encodeURIComponent(String(icon)))
                .replace("{".concat("colour", "}"), encodeURIComponent(String(colour)))
                .replace("{".concat("width", "}"), encodeURIComponent(String(width)))
                .replace("{".concat("height", "}"), encodeURIComponent(String(height)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets a map pin image
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} style Style of icon
         * @param {string} icon Icon name use. Use &#39;default&#39;, &#39;visited&#39; and &#39;active&#39; for our default pins
         * @param {string} colour Hex code (without #) to make the pin. Default defaults to STQRY colour
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [padding] Pad icon with whitespace
         * @param {number} [resize] Scale by the percentage given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageMapPinShow: function (device_platform, style, icon, colour, device_udid, padding, resize, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling imageMapPinShow.');
            }
            // verify required parameter 'style' is not null or undefined
            if (style === null || style === undefined) {
                throw new RequiredError('style', 'Required parameter style was null or undefined when calling imageMapPinShow.');
            }
            // verify required parameter 'icon' is not null or undefined
            if (icon === null || icon === undefined) {
                throw new RequiredError('icon', 'Required parameter icon was null or undefined when calling imageMapPinShow.');
            }
            // verify required parameter 'colour' is not null or undefined
            if (colour === null || colour === undefined) {
                throw new RequiredError('colour', 'Required parameter colour was null or undefined when calling imageMapPinShow.');
            }
            var localVarPath = "/api/v3/images/map_pin/{style}/{colour}/{icon(.png)}"
                .replace("{".concat("style", "}"), encodeURIComponent(String(style)))
                .replace("{".concat("icon", "}"), encodeURIComponent(String(icon)))
                .replace("{".concat("colour", "}"), encodeURIComponent(String(colour)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            if (padding !== undefined) {
                localVarQueryParameter['padding'] = padding;
            }
            if (resize !== undefined) {
                localVarQueryParameter['resize'] = resize;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the IAP's for an individual app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inAppPurchasesIndex: function (device_platform, version, language, device_udid, page, per_page, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling inAppPurchasesIndex.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling inAppPurchasesIndex.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling inAppPurchasesIndex.');
            }
            var localVarPath = "/api/v3/in_app_purchases/{language}/{version}"
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (per_page !== undefined) {
                localVarQueryParameter['per_page'] = per_page;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the information for an individual IAP
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inAppPurchasesShow: function (device_platform, version, language, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling inAppPurchasesShow.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling inAppPurchasesShow.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling inAppPurchasesShow.');
            }
            var localVarPath = "/api/v3/in_app_purchases/{id}/{language}/{version}"
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the information for an individual map route
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {number} id The map route ID to return
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapRouteShow: function (device_platform, version, language, id, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling mapRouteShow.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling mapRouteShow.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling mapRouteShow.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling mapRouteShow.');
            }
            var localVarPath = "/api/v3/map_routes/{id}/{language}/{version}"
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)))
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the information for an individual media item
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaItemsShow: function (device_platform, id, version, language, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling mediaItemsShow.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling mediaItemsShow.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling mediaItemsShow.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling mediaItemsShow.');
            }
            var localVarPath = "/api/v3/media_items/{id}/{language}/{version}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API create an order and order items
         * @param {CreateOrderBody} [create_order_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreate: function (create_order_body, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v3/orders";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateOrderBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(create_order_body || {}) : (create_order_body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the information for an order
         * @param {number} id ID of the Order to retrieve
         * @param {string} [stripe_payment_intent_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderShow: function (id, stripe_payment_intent_id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling orderShow.');
            }
            var localVarPath = "/api/v3/orders/{id}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (stripe_payment_intent_id !== undefined) {
                localVarQueryParameter['stripe_payment_intent_id'] = stripe_payment_intent_id;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Return payment configuration (e.g. Stripe publishable key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentConfig: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v3/payment/configs";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Log native purchase
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {CreatePaymentNativePurchaseBody} [create_payment_native_purchase_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentNativePurchase: function (device_platform, create_payment_native_purchase_body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling paymentNativePurchase.');
            }
            var localVarPath = "/api/v3/payment/native_purchase";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreatePaymentNativePurchaseBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(create_payment_native_purchase_body || {}) : (create_payment_native_purchase_body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the geofences for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectGeofences: function (device_platform, language, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling projectGeofences.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling projectGeofences.');
            }
            var localVarPath = "/api/v3/project/geofences/{language}/{version}"
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the manifest for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [full]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectManifest: function (device_platform, device_udid, full, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling projectManifest.');
            }
            var localVarPath = "/api/v3/project/manifest";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            if (full !== undefined) {
                localVarQueryParameter['full'] = full;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the top level Project metadata
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectShow: function (device_platform, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling projectShow.');
            }
            var localVarPath = "/api/v3/project";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the theme for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTheme: function (device_platform, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling projectTheme.');
            }
            var localVarPath = "/api/v3/project/theme";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the UUID for the whole project
         * @param {number} id The project ID to return
         * @param {ValidateToken} [validate_token] project app token with short token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectToken: function (id, validate_token, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling projectToken.');
            }
            var localVarPath = "/api/v3/project/token/{id}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ValidateToken" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(validate_token || {}) : (validate_token || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the information for an individual quiz (includes the questions and answers)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizzesShow: function (device_platform, id, version, language, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling quizzesShow.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling quizzesShow.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling quizzesShow.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling quizzesShow.');
            }
            var localVarPath = "/api/v3/quizzes/{id}/{language}/{version}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API redeem a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {RedeemCode} [redeem_code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCode: function (device_platform, device_udid, redeem_code, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling redeemCode.');
            }
            var localVarPath = "/api/v3/codes/redeem";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("RedeemCode" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(redeem_code || {}) : (redeem_code || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API retrieves a specific deep linking url
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {RetrieveDeepLinkURL} [retrieve_deep_link_url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDeepLinkURL: function (device_platform, device_udid, retrieve_deep_link_url, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling retrieveDeepLinkURL.');
            }
            var localVarPath = "/api/v3/deferred_deep_linking/retrieve";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("RetrieveDeepLinkURL" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(retrieve_deep_link_url || {}) : (retrieve_deep_link_url || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets the manifest for a screen
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The screen ID to return
         * @param {number} version The version number of this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        screenManifest: function (device_platform, id, version, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling screenManifest.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling screenManifest.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling screenManifest.');
            }
            var localVarPath = "/api/v3/screens/{id}/manifest"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API gets an individual Screen
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The screen ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        screensShow: function (device_platform, id, version, language, device_udid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling screensShow.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling screensShow.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling screensShow.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language', 'Required parameter language was null or undefined when calling screensShow.');
            }
            var localVarPath = "/api/v3/screens/{id}/{language}/{version}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("version", "}"), encodeURIComponent(String(version)))
                .replace("{".concat("language", "}"), encodeURIComponent(String(language)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API stores a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {StoreDeepLinkURL} [store_deep_link_url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeDeepLinkURL: function (device_platform, device_udid, store_deep_link_url, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling storeDeepLinkURL.');
            }
            var localVarPath = "/api/v3/deferred_deep_linking/store";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreDeepLinkURL" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(store_deep_link_url || {}) : (store_deep_link_url || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This API validates a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [coupon_code]
         * @param {number} [linked_id]
         * @param {string} [linked_type]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCode: function (device_platform, device_udid, coupon_code, linked_id, linked_type, email, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'device_platform' is not null or undefined
            if (device_platform === null || device_platform === undefined) {
                throw new RequiredError('device_platform', 'Required parameter device_platform was null or undefined when calling validateCode.');
            }
            var localVarPath = "/api/v3/codes/validate";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            if (device_platform !== undefined) {
                localVarQueryParameter['device_platform'] = device_platform;
            }
            if (device_udid !== undefined) {
                localVarQueryParameter['device_udid'] = device_udid;
            }
            if (coupon_code !== undefined) {
                localVarQueryParameter['coupon_code'] = coupon_code;
            }
            if (linked_id !== undefined) {
                localVarQueryParameter['linked_id'] = linked_id;
            }
            if (linked_type !== undefined) {
                localVarQueryParameter['linked_type'] = linked_type;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MytoursApiFetchParamCreator = MytoursApiFetchParamCreator;
/**
 * MytoursApi - functional programming interface
 * @export
 */
var MytoursApiFp = function (configuration) {
    return {
        /**
         *
         * @summary This API gets the manifest for the whole app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appManifest: function (device_platform, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).appManifest(device_platform, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the top level app metadata
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appShow: function (device_platform, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).appShow(device_platform, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the UUID for the whole app
         * @param {number} id The app ID to return
         * @param {ValidateToken} [validate_token] Validate app token with short token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appToken: function (id, validate_token, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).appToken(id, validate_token, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the information for an individual badge group (includes the badges and triggers)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeGroupsShow: function (device_platform, id, version, language, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).badgeGroupsShow(device_platform, id, version, language, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the collection items for an individual collection
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionItemsIndex: function (device_platform, id, version, language, device_udid, page, per_page, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).collectionItemsIndex(device_platform, id, version, language, device_udid, page, per_page, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the manifest for a collection
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionManifest: function (device_platform, id, version, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).collectionManifest(device_platform, id, version, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the collection triggers for an individual collection
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionTriggersIndex: function (id, version, language, page, per_page, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).collectionTriggersIndex(id, version, language, page, per_page, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the information for an individual collection (excludes the items)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionsShow: function (device_platform, id, version, language, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).collectionsShow(device_platform, id, version, language, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the information for a CustomWidget
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id ID of CustomWidget to show
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customWidgetShow: function (device_platform, id, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).customWidgetShow(device_platform, id, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the top level Project metadata for a display
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} uuid The display UUID to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        displayShow: function (device_platform, uuid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).displayShow(device_platform, uuid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets an individual form
         * @param {number} id ID of Form to show
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formShow: function (id, version, language, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).formShow(id, version, language, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API submits a form
         * @param {number} id ID of Form to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSubmit: function (id, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).formSubmit(id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets an icon image
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} style Style of icon
         * @param {string} icon Icon name use. Use &#39;default&#39;, &#39;visited&#39; and &#39;active&#39; for our default pins
         * @param {string} colour Hex code (without #) to make the pin. Default defaults to STQRY colour
         * @param {number} width Width in pixels
         * @param {number} height Height in pixels
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageIconShow: function (device_platform, style, icon, colour, width, height, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).imageIconShow(device_platform, style, icon, colour, width, height, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets a map pin image
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} style Style of icon
         * @param {string} icon Icon name use. Use &#39;default&#39;, &#39;visited&#39; and &#39;active&#39; for our default pins
         * @param {string} colour Hex code (without #) to make the pin. Default defaults to STQRY colour
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [padding] Pad icon with whitespace
         * @param {number} [resize] Scale by the percentage given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageMapPinShow: function (device_platform, style, icon, colour, device_udid, padding, resize, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).imageMapPinShow(device_platform, style, icon, colour, device_udid, padding, resize, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the IAP's for an individual app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inAppPurchasesIndex: function (device_platform, version, language, device_udid, page, per_page, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).inAppPurchasesIndex(device_platform, version, language, device_udid, page, per_page, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the information for an individual IAP
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inAppPurchasesShow: function (device_platform, version, language, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).inAppPurchasesShow(device_platform, version, language, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the information for an individual map route
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {number} id The map route ID to return
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapRouteShow: function (device_platform, version, language, id, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).mapRouteShow(device_platform, version, language, id, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the information for an individual media item
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaItemsShow: function (device_platform, id, version, language, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).mediaItemsShow(device_platform, id, version, language, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API create an order and order items
         * @param {CreateOrderBody} [create_order_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreate: function (create_order_body, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).orderCreate(create_order_body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the information for an order
         * @param {number} id ID of the Order to retrieve
         * @param {string} [stripe_payment_intent_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderShow: function (id, stripe_payment_intent_id, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).orderShow(id, stripe_payment_intent_id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Return payment configuration (e.g. Stripe publishable key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentConfig: function (options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).paymentConfig(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Log native purchase
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {CreatePaymentNativePurchaseBody} [create_payment_native_purchase_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentNativePurchase: function (device_platform, create_payment_native_purchase_body, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).paymentNativePurchase(device_platform, create_payment_native_purchase_body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the geofences for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectGeofences: function (device_platform, language, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).projectGeofences(device_platform, language, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the manifest for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [full]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectManifest: function (device_platform, device_udid, full, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).projectManifest(device_platform, device_udid, full, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the top level Project metadata
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectShow: function (device_platform, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).projectShow(device_platform, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the theme for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTheme: function (device_platform, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).projectTheme(device_platform, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the UUID for the whole project
         * @param {number} id The project ID to return
         * @param {ValidateToken} [validate_token] project app token with short token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectToken: function (id, validate_token, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).projectToken(id, validate_token, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the information for an individual quiz (includes the questions and answers)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizzesShow: function (device_platform, id, version, language, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).quizzesShow(device_platform, id, version, language, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API redeem a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {RedeemCode} [redeem_code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCode: function (device_platform, device_udid, redeem_code, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).redeemCode(device_platform, device_udid, redeem_code, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API retrieves a specific deep linking url
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {RetrieveDeepLinkURL} [retrieve_deep_link_url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDeepLinkURL: function (device_platform, device_udid, retrieve_deep_link_url, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).retrieveDeepLinkURL(device_platform, device_udid, retrieve_deep_link_url, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets the manifest for a screen
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The screen ID to return
         * @param {number} version The version number of this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        screenManifest: function (device_platform, id, version, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).screenManifest(device_platform, id, version, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API gets an individual Screen
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The screen ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        screensShow: function (device_platform, id, version, language, device_udid, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).screensShow(device_platform, id, version, language, device_udid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API stores a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {StoreDeepLinkURL} [store_deep_link_url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeDeepLinkURL: function (device_platform, device_udid, store_deep_link_url, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).storeDeepLinkURL(device_platform, device_udid, store_deep_link_url, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary This API validates a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [coupon_code]
         * @param {number} [linked_id]
         * @param {string} [linked_type]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCode: function (device_platform, device_udid, coupon_code, linked_id, linked_type, email, options) {
            var localVarFetchArgs = (0, exports.MytoursApiFetchParamCreator)(configuration).validateCode(device_platform, device_udid, coupon_code, linked_id, linked_type, email, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MytoursApiFp = MytoursApiFp;
/**
 * MytoursApi - factory interface
 * @export
 */
var MytoursApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary This API gets the manifest for the whole app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appManifest: function (device_platform, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).appManifest(device_platform, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the top level app metadata
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appShow: function (device_platform, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).appShow(device_platform, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the UUID for the whole app
         * @param {number} id The app ID to return
         * @param {ValidateToken} [validate_token] Validate app token with short token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appToken: function (id, validate_token, options) {
            return (0, exports.MytoursApiFp)(configuration).appToken(id, validate_token, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the information for an individual badge group (includes the badges and triggers)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeGroupsShow: function (device_platform, id, version, language, options) {
            return (0, exports.MytoursApiFp)(configuration).badgeGroupsShow(device_platform, id, version, language, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the collection items for an individual collection
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionItemsIndex: function (device_platform, id, version, language, device_udid, page, per_page, options) {
            return (0, exports.MytoursApiFp)(configuration).collectionItemsIndex(device_platform, id, version, language, device_udid, page, per_page, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the manifest for a collection
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionManifest: function (device_platform, id, version, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).collectionManifest(device_platform, id, version, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the collection triggers for an individual collection
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionTriggersIndex: function (id, version, language, page, per_page, options) {
            return (0, exports.MytoursApiFp)(configuration).collectionTriggersIndex(id, version, language, page, per_page, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the information for an individual collection (excludes the items)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionsShow: function (device_platform, id, version, language, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).collectionsShow(device_platform, id, version, language, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the information for a CustomWidget
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id ID of CustomWidget to show
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customWidgetShow: function (device_platform, id, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).customWidgetShow(device_platform, id, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the top level Project metadata for a display
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} uuid The display UUID to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        displayShow: function (device_platform, uuid, options) {
            return (0, exports.MytoursApiFp)(configuration).displayShow(device_platform, uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets an individual form
         * @param {number} id ID of Form to show
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formShow: function (id, version, language, options) {
            return (0, exports.MytoursApiFp)(configuration).formShow(id, version, language, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API submits a form
         * @param {number} id ID of Form to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSubmit: function (id, options) {
            return (0, exports.MytoursApiFp)(configuration).formSubmit(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets an icon image
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} style Style of icon
         * @param {string} icon Icon name use. Use &#39;default&#39;, &#39;visited&#39; and &#39;active&#39; for our default pins
         * @param {string} colour Hex code (without #) to make the pin. Default defaults to STQRY colour
         * @param {number} width Width in pixels
         * @param {number} height Height in pixels
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageIconShow: function (device_platform, style, icon, colour, width, height, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).imageIconShow(device_platform, style, icon, colour, width, height, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets a map pin image
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} style Style of icon
         * @param {string} icon Icon name use. Use &#39;default&#39;, &#39;visited&#39; and &#39;active&#39; for our default pins
         * @param {string} colour Hex code (without #) to make the pin. Default defaults to STQRY colour
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [padding] Pad icon with whitespace
         * @param {number} [resize] Scale by the percentage given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageMapPinShow: function (device_platform, style, icon, colour, device_udid, padding, resize, options) {
            return (0, exports.MytoursApiFp)(configuration).imageMapPinShow(device_platform, style, icon, colour, device_udid, padding, resize, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the IAP's for an individual app
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {number} [page] The page number to return for a paginated list
         * @param {number} [per_page] The number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inAppPurchasesIndex: function (device_platform, version, language, device_udid, page, per_page, options) {
            return (0, exports.MytoursApiFp)(configuration).inAppPurchasesIndex(device_platform, version, language, device_udid, page, per_page, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the information for an individual IAP
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inAppPurchasesShow: function (device_platform, version, language, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).inAppPurchasesShow(device_platform, version, language, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the information for an individual map route
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {number} id The map route ID to return
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapRouteShow: function (device_platform, version, language, id, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).mapRouteShow(device_platform, version, language, id, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the information for an individual media item
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaItemsShow: function (device_platform, id, version, language, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).mediaItemsShow(device_platform, id, version, language, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API create an order and order items
         * @param {CreateOrderBody} [create_order_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreate: function (create_order_body, options) {
            return (0, exports.MytoursApiFp)(configuration).orderCreate(create_order_body, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the information for an order
         * @param {number} id ID of the Order to retrieve
         * @param {string} [stripe_payment_intent_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderShow: function (id, stripe_payment_intent_id, options) {
            return (0, exports.MytoursApiFp)(configuration).orderShow(id, stripe_payment_intent_id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Return payment configuration (e.g. Stripe publishable key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentConfig: function (options) {
            return (0, exports.MytoursApiFp)(configuration).paymentConfig(options)(fetch, basePath);
        },
        /**
         *
         * @summary Log native purchase
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {CreatePaymentNativePurchaseBody} [create_payment_native_purchase_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentNativePurchase: function (device_platform, create_payment_native_purchase_body, options) {
            return (0, exports.MytoursApiFp)(configuration).paymentNativePurchase(device_platform, create_payment_native_purchase_body, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the geofences for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectGeofences: function (device_platform, language, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).projectGeofences(device_platform, language, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the manifest for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [full]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectManifest: function (device_platform, device_udid, full, options) {
            return (0, exports.MytoursApiFp)(configuration).projectManifest(device_platform, device_udid, full, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the top level Project metadata
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectShow: function (device_platform, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).projectShow(device_platform, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the theme for the whole project
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectTheme: function (device_platform, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).projectTheme(device_platform, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the UUID for the whole project
         * @param {number} id The project ID to return
         * @param {ValidateToken} [validate_token] project app token with short token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectToken: function (id, validate_token, options) {
            return (0, exports.MytoursApiFp)(configuration).projectToken(id, validate_token, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the information for an individual quiz (includes the questions and answers)
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The collection ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizzesShow: function (device_platform, id, version, language, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).quizzesShow(device_platform, id, version, language, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API redeem a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {RedeemCode} [redeem_code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCode: function (device_platform, device_udid, redeem_code, options) {
            return (0, exports.MytoursApiFp)(configuration).redeemCode(device_platform, device_udid, redeem_code, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API retrieves a specific deep linking url
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {RetrieveDeepLinkURL} [retrieve_deep_link_url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDeepLinkURL: function (device_platform, device_udid, retrieve_deep_link_url, options) {
            return (0, exports.MytoursApiFp)(configuration).retrieveDeepLinkURL(device_platform, device_udid, retrieve_deep_link_url, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets the manifest for a screen
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The screen ID to return
         * @param {number} version The version number of this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        screenManifest: function (device_platform, id, version, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).screenManifest(device_platform, id, version, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API gets an individual Screen
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {number} id The screen ID to return
         * @param {number} version The version number of this collection
         * @param {string} language The 2 letter language code for this collection
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        screensShow: function (device_platform, id, version, language, device_udid, options) {
            return (0, exports.MytoursApiFp)(configuration).screensShow(device_platform, id, version, language, device_udid, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API stores a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {StoreDeepLinkURL} [store_deep_link_url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeDeepLinkURL: function (device_platform, device_udid, store_deep_link_url, options) {
            return (0, exports.MytoursApiFp)(configuration).storeDeepLinkURL(device_platform, device_udid, store_deep_link_url, options)(fetch, basePath);
        },
        /**
         *
         * @summary This API validates a specific code
         * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
         * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
         * @param {string} [coupon_code]
         * @param {number} [linked_id]
         * @param {string} [linked_type]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCode: function (device_platform, device_udid, coupon_code, linked_id, linked_type, email, options) {
            return (0, exports.MytoursApiFp)(configuration).validateCode(device_platform, device_udid, coupon_code, linked_id, linked_type, email, options)(fetch, basePath);
        },
    };
};
exports.MytoursApiFactory = MytoursApiFactory;
/**
 * MytoursApi - object-oriented interface
 * @export
 * @class MytoursApi
 * @extends {BaseAPI}
 */
var MytoursApi = /** @class */ (function (_super) {
    __extends(MytoursApi, _super);
    function MytoursApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary This API gets the manifest for the whole app
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.appManifest = function (device_platform, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).appManifest(device_platform, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the top level app metadata
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.appShow = function (device_platform, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).appShow(device_platform, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the UUID for the whole app
     * @param {number} id The app ID to return
     * @param {ValidateToken} [validate_token] Validate app token with short token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.appToken = function (id, validate_token, options) {
        return (0, exports.MytoursApiFp)(this.configuration).appToken(id, validate_token, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the information for an individual badge group (includes the badges and triggers)
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id The collection ID to return
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.badgeGroupsShow = function (device_platform, id, version, language, options) {
        return (0, exports.MytoursApiFp)(this.configuration).badgeGroupsShow(device_platform, id, version, language, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the collection items for an individual collection
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id The collection ID to return
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {number} [page] The page number to return for a paginated list
     * @param {number} [per_page] The number of items to return per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.collectionItemsIndex = function (device_platform, id, version, language, device_udid, page, per_page, options) {
        return (0, exports.MytoursApiFp)(this.configuration).collectionItemsIndex(device_platform, id, version, language, device_udid, page, per_page, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the manifest for a collection
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id The collection ID to return
     * @param {number} version The version number of this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.collectionManifest = function (device_platform, id, version, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).collectionManifest(device_platform, id, version, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the collection triggers for an individual collection
     * @param {number} id The collection ID to return
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {number} [page] The page number to return for a paginated list
     * @param {number} [per_page] The number of items to return per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.collectionTriggersIndex = function (id, version, language, page, per_page, options) {
        return (0, exports.MytoursApiFp)(this.configuration).collectionTriggersIndex(id, version, language, page, per_page, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the information for an individual collection (excludes the items)
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id The collection ID to return
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.collectionsShow = function (device_platform, id, version, language, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).collectionsShow(device_platform, id, version, language, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the information for a CustomWidget
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id ID of CustomWidget to show
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.customWidgetShow = function (device_platform, id, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).customWidgetShow(device_platform, id, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the top level Project metadata for a display
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} uuid The display UUID to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.displayShow = function (device_platform, uuid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).displayShow(device_platform, uuid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets an individual form
     * @param {number} id ID of Form to show
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.formShow = function (id, version, language, options) {
        return (0, exports.MytoursApiFp)(this.configuration).formShow(id, version, language, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API submits a form
     * @param {number} id ID of Form to submit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.formSubmit = function (id, options) {
        return (0, exports.MytoursApiFp)(this.configuration).formSubmit(id, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets an icon image
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} style Style of icon
     * @param {string} icon Icon name use. Use &#39;default&#39;, &#39;visited&#39; and &#39;active&#39; for our default pins
     * @param {string} colour Hex code (without #) to make the pin. Default defaults to STQRY colour
     * @param {number} width Width in pixels
     * @param {number} height Height in pixels
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.imageIconShow = function (device_platform, style, icon, colour, width, height, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).imageIconShow(device_platform, style, icon, colour, width, height, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets a map pin image
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} style Style of icon
     * @param {string} icon Icon name use. Use &#39;default&#39;, &#39;visited&#39; and &#39;active&#39; for our default pins
     * @param {string} colour Hex code (without #) to make the pin. Default defaults to STQRY colour
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {string} [padding] Pad icon with whitespace
     * @param {number} [resize] Scale by the percentage given
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.imageMapPinShow = function (device_platform, style, icon, colour, device_udid, padding, resize, options) {
        return (0, exports.MytoursApiFp)(this.configuration).imageMapPinShow(device_platform, style, icon, colour, device_udid, padding, resize, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the IAP's for an individual app
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {number} [page] The page number to return for a paginated list
     * @param {number} [per_page] The number of items to return per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.inAppPurchasesIndex = function (device_platform, version, language, device_udid, page, per_page, options) {
        return (0, exports.MytoursApiFp)(this.configuration).inAppPurchasesIndex(device_platform, version, language, device_udid, page, per_page, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the information for an individual IAP
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.inAppPurchasesShow = function (device_platform, version, language, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).inAppPurchasesShow(device_platform, version, language, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the information for an individual map route
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {number} id The map route ID to return
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.mapRouteShow = function (device_platform, version, language, id, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).mapRouteShow(device_platform, version, language, id, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the information for an individual media item
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id The collection ID to return
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.mediaItemsShow = function (device_platform, id, version, language, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).mediaItemsShow(device_platform, id, version, language, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API create an order and order items
     * @param {CreateOrderBody} [create_order_body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.orderCreate = function (create_order_body, options) {
        return (0, exports.MytoursApiFp)(this.configuration).orderCreate(create_order_body, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the information for an order
     * @param {number} id ID of the Order to retrieve
     * @param {string} [stripe_payment_intent_id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.orderShow = function (id, stripe_payment_intent_id, options) {
        return (0, exports.MytoursApiFp)(this.configuration).orderShow(id, stripe_payment_intent_id, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Return payment configuration (e.g. Stripe publishable key)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.paymentConfig = function (options) {
        return (0, exports.MytoursApiFp)(this.configuration).paymentConfig(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Log native purchase
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {CreatePaymentNativePurchaseBody} [create_payment_native_purchase_body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.paymentNativePurchase = function (device_platform, create_payment_native_purchase_body, options) {
        return (0, exports.MytoursApiFp)(this.configuration).paymentNativePurchase(device_platform, create_payment_native_purchase_body, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the geofences for the whole project
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} language The 2 letter language code for this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.projectGeofences = function (device_platform, language, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).projectGeofences(device_platform, language, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the manifest for the whole project
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {string} [full]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.projectManifest = function (device_platform, device_udid, full, options) {
        return (0, exports.MytoursApiFp)(this.configuration).projectManifest(device_platform, device_udid, full, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the top level Project metadata
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.projectShow = function (device_platform, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).projectShow(device_platform, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the theme for the whole project
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.projectTheme = function (device_platform, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).projectTheme(device_platform, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the UUID for the whole project
     * @param {number} id The project ID to return
     * @param {ValidateToken} [validate_token] project app token with short token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.projectToken = function (id, validate_token, options) {
        return (0, exports.MytoursApiFp)(this.configuration).projectToken(id, validate_token, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the information for an individual quiz (includes the questions and answers)
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id The collection ID to return
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.quizzesShow = function (device_platform, id, version, language, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).quizzesShow(device_platform, id, version, language, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API redeem a specific code
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {RedeemCode} [redeem_code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.redeemCode = function (device_platform, device_udid, redeem_code, options) {
        return (0, exports.MytoursApiFp)(this.configuration).redeemCode(device_platform, device_udid, redeem_code, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API retrieves a specific deep linking url
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {RetrieveDeepLinkURL} [retrieve_deep_link_url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.retrieveDeepLinkURL = function (device_platform, device_udid, retrieve_deep_link_url, options) {
        return (0, exports.MytoursApiFp)(this.configuration).retrieveDeepLinkURL(device_platform, device_udid, retrieve_deep_link_url, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets the manifest for a screen
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id The screen ID to return
     * @param {number} version The version number of this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.screenManifest = function (device_platform, id, version, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).screenManifest(device_platform, id, version, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API gets an individual Screen
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {number} id The screen ID to return
     * @param {number} version The version number of this collection
     * @param {string} language The 2 letter language code for this collection
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.screensShow = function (device_platform, id, version, language, device_udid, options) {
        return (0, exports.MytoursApiFp)(this.configuration).screensShow(device_platform, id, version, language, device_udid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API stores a specific code
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {StoreDeepLinkURL} [store_deep_link_url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.storeDeepLinkURL = function (device_platform, device_udid, store_deep_link_url, options) {
        return (0, exports.MytoursApiFp)(this.configuration).storeDeepLinkURL(device_platform, device_udid, store_deep_link_url, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary This API validates a specific code
     * @param {'ios' | 'android' | 'mobile_web'} device_platform Users device platform.
     * @param {string} [device_udid] Users unique device id. Generate a UUID on device.
     * @param {string} [coupon_code]
     * @param {number} [linked_id]
     * @param {string} [linked_type]
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MytoursApi
     */
    MytoursApi.prototype.validateCode = function (device_platform, device_udid, coupon_code, linked_id, linked_type, email, options) {
        return (0, exports.MytoursApiFp)(this.configuration).validateCode(device_platform, device_udid, coupon_code, linked_id, linked_type, email, options)(this.fetch, this.basePath);
    };
    return MytoursApi;
}(BaseAPI));
exports.MytoursApi = MytoursApi;
